unit DashboardForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WEBLib.DB,
  WEBLib.ExtCtrls,
  WEBLib.WebCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  Vcl.Grids,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Data.DB,
  BaseDashboardItem,
  DashboardItemFactory,
  DashboardParamsBuilder,
  Vcl.Imaging.GIFImg, WEBLib.TreeNodes, Vcl.ComCtrls, WEBLib.ComCtrls,
  WEBLib.CheckLst, System.Generics.Collections, SMX.XData.Utils, Sys.Return.Types,
  Simple.Dashboard.Return.Types, Simple.Dashboard.Bulk.Types;

type
  TDashboard = class(TForm)
    WaitMessage: TWaitMessage;
    WidgetHostPanel: TPanel;
    ChartTimer: TTimer;
    BranchTreeView: TTreeView;
    StartDatePicker: TDateTimePicker;
    EndDatePicker: TDateTimePicker;
    RefreshButton: TButton;
    ConfigurationButton: TButton;
    WebButton1: TButton;
    UserDashboardButton: TButton;
    RefreshDashboardItemsTimer: TTimer;
    WidgetOrderSaveTimer: TTimer;

    procedure WebFormShow(Sender: TObject);
    procedure ChartTimerTimer(Sender: TObject);
    [async]
    procedure RefreshButtonClick(Sender: TObject); async;
    procedure BranchTreeViewChange(Sender: TObject; Node: TTreeNode);
    procedure ConfigurationButtonClick(Sender: TObject);
    procedure UserDashboardButtonClick(Sender: TObject);
    [async]
    procedure RefreshDashboardItemsTimerTimer(Sender: TObject); async;
    [async]
    procedure WidgetOrderSaveTimerTimer(Sender: TObject); async;
    [async]
    procedure StartDatePickerChange(Sender: TObject); async;
    [async]
    procedure EndDatePickerChange(Sender: TObject); async;
  private
    { Private declarations }
    FUserId: integer;
    FSuppressDateRefresh: Boolean;
    FDashboardReady: Boolean;

    FDashboardParams: JS.TJSObject;
    //FDashboardParamsStr: string;
    FDashboardList: TStringList;

    FDashboardItemTemplates: TList<TDashboardItemTemplate>;
    FDashboardItemTitles: TList<TDashboardItemTitle>;

    FBranchStructureJSON: string;
    FGroupList: TStringList;
    FBranchList: TStringList;
    FBranchListForQuery: TStringList;
    FUserConfig: TUserConfig;
    FWebUserConfiguration: TUserConfiguration;
    FUserBranchList: TStringList;
    FStartDayOfWeek: integer;
    FUserBranchIds: string;
    FLastSavedWidgetOrder: string;
    FSuppressWidgetOrderSave: Boolean;

    function IsDashboardItemSelected(ADashboardItemId: Integer): Boolean;
    procedure CancelPendingWidgetOrderSave;
    procedure CreateDashboardShells;
    [async]
    procedure CreateDashboardItems; async;
    function CreateDashboardItemInstance(ADashBoardItemTemplate: TDashboardItemTemplate): TBaseDashboardItem;
    [async]
    procedure InitialiseDashboard; async;

    procedure InvalidateDashboardDataCache;

    [async]
    procedure RefreshDashboard(ADashboardId: integer); async;
    procedure UpdateDashboardItemsParameters;

    procedure GetDashboardItemList;
    procedure GetBranchIdsList;
    procedure UpdateBranchIdsList;
    procedure ImplementParameters;

    [async]
    procedure GetUserConfiguration; async;
    [async]
    function SetUserConfiguration: Boolean; async;

    [async]
    procedure GetBranches; async;
    procedure GetSelectedBranches;
    procedure BranchUpdate;
    function SortBranchIdsParameter:string;
    function ResolveEffectiveBranchIds: string;
    function NormalizeBranchId(const ABranchId: string): string;
    function CollectAllBranchIdsFromStructure: string;
    function FilterBranchStructureForUser(const ABranchStructure: string): string;
    function IsBranchAllowedForUser(const ABranchId: string): Boolean;
    function HasExplicitBranchScope: Boolean;
    function UserHasUnrestrictedBranches: Boolean;
    function CountAssignedBranches: Integer;
    procedure ClampBranchListToUserAccess;
    function ParseBranchListFromUserConfigJson(const AConfigJson: string): TArray<string>;
    function BranchListsMatch(const ALeft, ARight: TArray<string>): Boolean;
    function BranchIdsCsvToArray(const ABranchIdsCsv: string): TArray<string>;
    procedure ReloadPersistedBranchListFromUserConfig;
    procedure ApplyDefaultDashboardBranchesForUser;
    [async]
    procedure RefreshBranchAccessMetadata; async;
    procedure ScheduleWidgetOrderSave;
    procedure ApplyWidgetOrderFromDom;
    [async]
    procedure SaveDashboardWidgetOrder; async;
    function FindWidgetByDashboardItemId(ADashboardItemId: Integer): TBaseDashboardItem;
    function FindDashboardItemTitleById(ADashboardItemId: Integer): TDashboardItemTitle;
    function FindTemplateById(ADashboardItemId: Integer): TDashboardItemTemplate;
    procedure SyncListsToWidgetOrder(const AOrderedIds: TArray<Integer>);
    procedure CaptureWidgetOrderSignature;
    procedure ApplyDashboardOrderToItemTitles(AList: TList<TDashboardItemTitle>);
    procedure ApplyTemplateOrderToDom;

    [async]
    procedure GetUserDashboardItems; async;

    [async]
    procedure GetBranchStructure; async;
    [async]
    procedure ConfigurationPopUp; async;
//    procedure RefreshBranchTreeView;
    [async]
    procedure UserDashboardPopUp; async;
    [async]
    procedure SaveUserDashboardItems(AUserDashboardItemTitles: TList<TDashboardItemTitle>); async;

    [async]
    procedure RefreshDashboardItems; async;

    procedure SetLocalDefaultDateRange;

    function GetParameters(AParameters: TArray<String>; const ATitle: string): string;

    [async]
    procedure GetBranchList; async;

    [async]
    procedure ApplyDefaultDateRange; async;

    procedure EnsureDefaultWebUserConfiguration;
    procedure UpdateConfigurationButtonVisibility;

    procedure RelayoutDashboardWidgets;
    procedure HandleViewportResize;
    procedure ShowDashboardChrome;
    procedure SyncDatePickerInputs;
    procedure ShowAllWidgetSkeletons;
    procedure ShowDashboardLoading(AVisible: Boolean);
    procedure ClearOrphanWidgetSkeletons;
    procedure RemoveStaleDashboardWidgets;
    procedure CleanupDashboardLoadingState;
    procedure ShowEmptyDashboardMessage;

    function GetDashboardParamsString: string;
    [async]
    procedure FlushBrowserPaint; async;
    [async]
    procedure ApplyBulkWidgetData(const ABulk: TList<TDashboardBulkItem>); async;
    [async]
    procedure ReloadEmptyChartWidgets; async;
    procedure FinalizeBulkWidgetPresentation;
    [async]
    procedure LoadAllWidgetData; async;

    //    function SetParameters(lDashboardItem: TBaseDashboardItem):string;

  public
    { Public declarations }
//    function GetTenantDashboardItems: integer;
//    function GetTenantDashboardItems: TList<TDashboardItemTitle>;
    [async]
    procedure GetTenantDashboardItems; async;//: TList<TDashboardItemTitle>;

  protected procedure LoadDFMValues; override; end;

var
  Dashboard: TDashboard;

implementation

{$R *.dfm}

uses
  XData.Web.Client,
  MainForm,
  MainDataModule,
  SMX.Web.Service.Consts,
  SharedDataModule,
  SMX.Web.Utils,
  SMX.Web.Document.Utils,
  SMX.Web.Table.Simple,
  Auth.Service,
  Configuration,
  UserDashboardConfiguration,
  CSY.Enumerations;


procedure TDashboard.ShowDashboardChrome;
begin
  StartDatePicker.Visible := False;
  EndDatePicker.Visible := False;
  RefreshButton.Enabled := False;
  // Hidden until branch access is known — prevents flash for single-branch users
  ConfigurationButton.Visible := False;

  asm
    var start = document.getElementById('StartDate');
    var endDate = document.getElementById('EndDate');
    if (start) {
      start.style.visibility = 'hidden';
      start.value = '';
      start.setAttribute('disabled', 'disabled');
    }
    if (endDate) {
      endDate.style.visibility = 'hidden';
      endDate.value = '';
      endDate.setAttribute('disabled', 'disabled');
    }
    var startLabel = document.querySelector('label[for="StartDate"]');
    var endLabel = document.querySelector('label[for="EndDate"]');
    if (startLabel) {
      startLabel.style.visibility = 'hidden';
    }
    if (endLabel) {
      endLabel.style.visibility = 'hidden';
    }
    var configBtn = document.getElementById('Configuration');
    if (configBtn) {
      configBtn.classList.add('csy-config-hidden');
      configBtn.style.display = 'none';
      configBtn.setAttribute('hidden', 'hidden');
    }
    var row = (window.SMX && window.SMX.findDashboardWidgetsRow)
      ? window.SMX.findDashboardWidgetsRow()
      : document.getElementById('DashboardWidgetsRow');
    if (row) {
      row.style.display = 'grid';
      row.style.width = '100%';
      row.style.maxWidth = '100%';
      row.style.minWidth = '0';
      if (window.SMX && window.SMX.syncDashboardGridColumns) {
        window.SMX.syncDashboardGridColumns(row);
      }
    }
  end;
end;

procedure TDashboard.SyncDatePickerInputs;
begin
  StartDatePicker.Visible := True;
  EndDatePicker.Visible := True;

  asm
    var start = document.getElementById('StartDate');
    var endDate = document.getElementById('EndDate');
    if (start) {
      start.style.visibility = 'visible';
      start.removeAttribute('disabled');
    }
    if (endDate) {
      endDate.style.visibility = 'visible';
      endDate.removeAttribute('disabled');
    }
    var startLabel = document.querySelector('label[for="StartDate"]');
    var endLabel = document.querySelector('label[for="EndDate"]');
    if (startLabel) {
      startLabel.style.visibility = 'visible';
    }
    if (endLabel) {
      endLabel.style.visibility = 'visible';
    }
  end;
end;

procedure TDashboard.ShowAllWidgetSkeletons;
var
  lIdx: integer;
begin
  if not Assigned(FDashboardList) then
    Exit;

  for lIdx := 0 to FDashboardList.Count - 1 do
    TBaseDashboardItem(FDashboardList.Objects[lIdx]).ShowDataSkeleton;
end;

procedure TDashboard.InitialiseDashboard;
var
  lUserId: integer;
begin
  FUserId := MainData.UserId;
  FDashboardReady := False;
  FSuppressDateRefresh := True;

  WidthPercent := 100;
  WidthStyle := ssAuto;
  ElementClassName := 'w-100 csy-dashboard-page';

  FDashboardList := TStringList.Create;
  FDashboardItemTemplates := TList<TDashboardItemTemplate>.Create;

  FBranchListForQuery := TStringList.Create;
  FUserBranchList := TStringList.Create;

  EnsureDefaultWebUserConfiguration;
  ShowDashboardChrome;
  RefreshButton.Enabled := False;

  if FUserId = 0 then
    FUserId := AuthService.UserId;

  try
    if FUserId = 0 then
      FUserId := AuthService.UserId;
    if FUserId = 0 then
      MainPage.ShowAToast('Dashboard',
        'User id not found in login token. Log out and back in after rebuilding Sphinx.',
        'fad fa-exclamation-triangle');

    lUserId := FUserId;
    SetLocalDefaultDateRange;

    // Render the dashboard structure as soon as the metric definitions arrive.
    // The remaining configuration and branch requests can then run while the
    // user already sees the loading skeletons instead of an empty page.
    if lUserId <> 0 then
    begin
      FDashboardItemTemplates := Await(SharedData.Dashboard.GetDashboardItemTemplates(lUserId));
      ImplementParameters;
      CreateDashboardShells;
    end;

    await(ApplyDefaultDateRange);
    SyncDatePickerInputs;
    await(GetUserConfiguration);
    if Assigned(FWebUserConfiguration) then
      FStartDayOfWeek := FWebUserConfiguration.WeekStartDay;
  await(GetBranchList);
  ClampBranchListToUserAccess;
  ApplyDefaultDashboardBranchesForUser;
  // Persist healed branch list when group membership dropped stale ids
  if Assigned(FUserConfig) and Assigned(FWebUserConfiguration) then
  begin
    if not BranchListsMatch(ParseBranchListFromUserConfigJson(FUserConfig.Config),
      FWebUserConfiguration.BranchList) then
      await(SetUserConfiguration);
  end;
  await(GetBranches);
    // Decide Configuration visibility as soon as branch access is known
    UpdateConfigurationButtonVisibility;

    if lUserId <> 0 then
    begin
      FDashboardItemTemplates := Await(SharedData.Dashboard.GetDashboardItemTemplates(lUserId));
      ImplementParameters;
      CreateDashboardShells;
    end;

    ImplementParameters;

    if FDashboardList.Count > 0 then
      await(LoadAllWidgetData)
    else if lUserId <> 0 then
  await(GetUserDashboardItems);

    FDashboardReady := True;
    CaptureWidgetOrderSignature;
  except
    on E: Exception do
    begin
      SetLocalDefaultDateRange;
      MainPage.ShowAToast('Dashboard', E.Message, 'fad fa-exclamation-triangle');
      RefreshButton.Enabled := True;
    end;
  end;
  SyncDatePickerInputs;
  if (FDashboardList.Count = 0) and (not Assigned(FDashboardItemTemplates) or (FDashboardItemTemplates.Count = 0)) then
    ShowEmptyDashboardMessage;
  RefreshButton.Enabled := True;
  FSuppressDateRefresh := False;
end;

procedure TDashboard.InvalidateDashboardDataCache;
begin
  SharedData.Dashboard.ClearDashboardCache;
  SharedData.Dashboard.ClearBranchMetadataCache;
end;

procedure TDashboard.CreateDashboardShells;
var
  lIdx: integer;
  lDashboardItemTemplate: TDashboardItemTemplate;
  lDashboardItem: TBaseDashboardItem;
begin
  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lDashboardItem := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lDashboardItem.Free;
  end;
  FDashboardList.Clear;

  if not Assigned(FDashboardItemTemplates) then
    Exit;

  for lIdx := 0 to FDashboardItemTemplates.Count-1 do
  begin
    lDashboardItemTemplate := FDashboardItemTemplates[lIdx];
    try
      lDashboardItem := CreateDashboardItemInstance(lDashboardItemTemplate);
      if Assigned(lDashboardItem) then
      begin
        lDashboardItem.ElementPosition := epRelative;
        lDashboardItem.ChildOrder := lIdx;
        FDashboardList.AddObject(lDashboardItem.Title, lDashboardItem);
      end;
    except
      on E: Exception do
        console.log('CreateDashboardShells item failed: ' + E.Message);
    end;
  end;

  RelayoutDashboardWidgets;
  ApplyTemplateOrderToDom;
  ShowAllWidgetSkeletons;
end;

procedure TDashboard.CreateDashboardItems;
begin
  CreateDashboardShells;
  RelayoutDashboardWidgets;

  RefreshButton.Enabled := False;
  try
    await(LoadAllWidgetData);
  finally
    RefreshButton.Enabled := True;
  end;
end;

procedure TDashboard.RelayoutDashboardWidgets;
var
  lIdx: integer;
  lWidget: TBaseDashboardItem;
begin
  if not Assigned(FDashboardList) then
    Exit;

  asm
    function finalizeCsyWidget(widget) {
      if (!widget || !widget.id || widget.id.indexOf('csy_widget_') !== 0) {
        return;
      }

      var chartHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--csy-chart-height').trim() || '380px';

      var num = widget.id.replace('csy_widget_', '');
      var footerPanel = document.getElementById('csy_footer_' + num);
      var usesFooter = !widget.classList.contains('csy-chart-only') &&
        (widget.classList.contains('csy-uses-footer') ||
        (widget.classList.contains('csy-has-chart') && footerPanel));
      if (usesFooter && widget.classList.contains('csy-has-chart')) {
        widget.classList.add('csy-uses-footer', 'csy-chart-summary-fixed');
      }
      widget.classList.add('card', 'shadow-sm', 'csy-dashboard-card', 'csy-dashboard-widget-col', 'mb-0');
      widget.classList.remove('csy-widget-full-width');
      if (widget.classList.contains('csy-has-chart') && widget.classList.contains('csy-uses-footer')) {
        widget.classList.add('csy-chart-summary-fixed');
      }
      widget.style.position = 'relative';
      widget.style.left = 'auto';
      widget.style.top = 'auto';
      widget.style.width = '100%';
      widget.style.maxWidth = '100%';
      widget.style.height = 'auto';
      widget.style.minHeight = '0';
      widget.style.overflow = 'visible';
      widget.style.boxSizing = 'border-box';
      widget.style.display = 'flex';
      widget.style.flexDirection = 'column';

      var header = document.getElementById('csy_header_' + num);
      if (header && header.nodeType === 1 && header.parentElement !== widget) {
        widget.insertBefore(header, widget.firstChild);
      }
      if (header) {
        header.style.setProperty('position', 'relative', 'important');
        header.style.setProperty('width', '100%', 'important');
        header.style.setProperty('min-width', '100%', 'important');
        header.style.setProperty('max-width', '100%', 'important');
        header.style.setProperty('align-self', 'stretch', 'important');
        header.style.height = 'auto';
        header.style.display = 'flex';
        header.style.flexDirection = 'row';
        header.style.alignItems = 'center';
        header.style.justifyContent = 'space-between';
        header.style.gap = '0.75rem';
        header.style.padding = '0.875rem 1.5rem 0.875rem 1.75rem';
        header.style.boxSizing = 'border-box';
        header.classList.add('csy-card-header');
        if (window.SMX && window.SMX.ensureCsyDragHandle) {
          window.SMX.ensureCsyDragHandle(widget, header);
        }
      }

      var title = document.getElementById('csy_title_' + num);
      if (title && title.nodeType === 1 && header && header.nodeType === 1 && !header.contains(title)) {
        header.insertBefore(title, header.firstChild);
      }
      var titleText = widget.getAttribute('data-csy-title') || '';
      if (title) {
        title.style.position = 'relative';
        title.style.width = 'auto';
        title.style.maxWidth = '100%';
        title.style.flex = '1 1 auto';
        title.style.overflow = 'visible';
        title.style.whiteSpace = 'normal';
        title.style.display = 'block';
        var titleInner = title.querySelector('div') || title;
        if (titleText) {
          titleInner.textContent = titleText;
        }
        titleInner.style.width = 'auto';
        titleInner.style.maxWidth = '100%';
        titleInner.style.overflow = 'visible';
        titleInner.style.whiteSpace = 'normal';
      }

      var combo = document.getElementById('csy_combo_' + num);
      if (combo) {
        combo.remove();
      }

      var panels = document.querySelectorAll('[id^="csy_chart_' + num + '_"]');
      for (var p = 0; p < panels.length; p++) {
        var panel = panels[p];
        var body = document.getElementById('csy_body_' + num);
        if (body && !body.contains(panel)) {
          body.appendChild(panel);
        } else if (!widget.contains(panel)) {
          widget.appendChild(panel);
        }
        panel.style.position = 'relative';
        panel.style.width = '100%';
        panel.style.maxWidth = '100%';
        panel.style.left = 'auto';
        panel.style.top = 'auto';
        panel.style.display = 'flex';
        panel.style.flexDirection = 'column';
        panel.style.height = chartHeight;
        panel.style.minHeight = chartHeight;
        panel.style.maxHeight = chartHeight;
        panel.style.flex = '0 0 ' + chartHeight;
        panel.style.overflow = 'hidden';
        panel.style.boxSizing = 'border-box';
        panel.style.visibility = '';
        panel.style.display = 'flex';
        panel.removeAttribute('data-csy-hidden-for-load');
        panel.removeAttribute('aria-hidden');
      }

      var chartCanvases = widget.querySelectorAll('[id^="csy_chart_"]:not([id$="_panel"])');
      for (var cc = 0; cc < chartCanvases.length; cc++) {
        chartCanvases[cc].style.position = 'absolute';
        chartCanvases[cc].style.inset = '0';
        chartCanvases[cc].style.width = '100%';
        chartCanvases[cc].style.height = '100%';
        chartCanvases[cc].style.maxWidth = '100%';
        chartCanvases[cc].style.maxHeight = '100%';
        if (chartCanvases[cc].__csyChart && typeof chartCanvases[cc].__csyChart.resize === 'function') {
          chartCanvases[cc].__csyChart.resize();
        }
      }

      var bodyPanel = document.getElementById('csy_body_' + num);
      if (bodyPanel && header) {
        if (header.nextSibling !== bodyPanel) {
          if (header.nextSibling) {
            widget.insertBefore(bodyPanel, header.nextSibling);
          } else {
            widget.appendChild(bodyPanel);
          }
        }
        bodyPanel.style.position = 'relative';
        bodyPanel.style.left = 'auto';
        bodyPanel.style.top = 'auto';
        bodyPanel.style.right = 'auto';
        bodyPanel.style.bottom = 'auto';
        bodyPanel.style.width = '100%';
        bodyPanel.style.maxWidth = '100%';
        if (widget.classList.contains('csy-has-chart')) {
          bodyPanel.style.display = 'flex';
          bodyPanel.style.flexDirection = 'column';
          bodyPanel.style.padding = '0';
          bodyPanel.style.gap = '0';
          bodyPanel.style.boxSizing = 'border-box';
        }
        if (widget.classList.contains('csy-has-chart')) {
          if (usesFooter) {
            widget.classList.add('csy-chart-summary-fixed', 'csy-uses-footer');
          }
          bodyPanel.style.height = chartHeight;
          bodyPanel.style.minHeight = chartHeight;
          bodyPanel.style.maxHeight = chartHeight;
          bodyPanel.style.flex = '0 0 ' + chartHeight;
          bodyPanel.style.flexShrink = '0';
          bodyPanel.style.flexGrow = '0';
          bodyPanel.style.overflow = 'hidden';
          bodyPanel.style.gap = '0';
          bodyPanel.style.paddingBottom = '0';
        } else {
          var bodySummaryHeight = widget.getAttribute('data-csy-summary-height');
          if (bodySummaryHeight) {
            bodyPanel.style.height = bodySummaryHeight;
            bodyPanel.style.minHeight = bodySummaryHeight;
            bodyPanel.style.maxHeight = bodySummaryHeight;
            bodyPanel.style.flex = '0 0 ' + bodySummaryHeight;
            bodyPanel.style.overflow = 'hidden';
          } else {
            bodyPanel.style.height = '';
            bodyPanel.style.minHeight = '0';
            bodyPanel.style.maxHeight = '';
            bodyPanel.style.flex = '0 0 auto';
            bodyPanel.style.overflow = 'hidden';
          }
        }
        bodyPanel.style.boxSizing = 'border-box';
        bodyPanel.classList.add('csy-card-body', 'card-body');
      }

      usesFooter = !widget.classList.contains('csy-chart-only') &&
        (widget.classList.contains('csy-uses-footer') ||
        (widget.classList.contains('csy-has-chart') && footerPanel));
      if (footerPanel) {
        if (usesFooter) {
          if (bodyPanel) {
            if (footerPanel.parentElement !== widget || bodyPanel.nextSibling !== footerPanel) {
              widget.appendChild(footerPanel);
            }
          } else if (!widget.contains(footerPanel)) {
            widget.appendChild(footerPanel);
          }
          footerPanel.style.display = 'block';
          footerPanel.style.position = 'relative';
          footerPanel.style.left = 'auto';
          footerPanel.style.top = 'auto';
          footerPanel.style.right = 'auto';
          footerPanel.style.bottom = 'auto';
          footerPanel.style.width = '100%';
          footerPanel.style.maxWidth = '100%';
          if (usesFooter && widget.classList.contains('csy-has-chart')) {
            widget.classList.add('csy-chart-summary-fixed', 'csy-uses-footer');
            footerPanel.style.height = 'auto';
            footerPanel.style.minHeight = '0';
            footerPanel.style.maxHeight = 'var(--csy-chart-summary-footer-height, 108px)';
            footerPanel.style.flex = '0 0 auto';
            footerPanel.style.flexShrink = '0';
            footerPanel.style.flexGrow = '0';
            footerPanel.style.padding = '0';
            footerPanel.style.overflowX = 'hidden';
            footerPanel.style.overflowY = 'auto';
          } else if (widget.classList.contains('csy-chart-summary-fixed')) {
            footerPanel.style.height = 'auto';
            footerPanel.style.minHeight = '0';
            footerPanel.style.maxHeight = 'var(--csy-chart-summary-footer-height, 108px)';
            footerPanel.style.flex = '0 0 auto';
            footerPanel.style.overflowX = 'hidden';
            footerPanel.style.overflowY = 'auto';
          }
          footerPanel.style.boxSizing = 'border-box';
          footerPanel.style.zIndex = '0';
          footerPanel.classList.add('csy-card-footer', 'card-footer');
        } else {
          footerPanel.style.display = 'none';
        }
      }

      var summary = document.getElementById('csy_summary_' + num);
      if (summary) {
        var summaryParent = usesFooter ? footerPanel : bodyPanel;
        if (usesFooter && footerPanel && bodyPanel && bodyPanel.contains(summary)) {
          footerPanel.appendChild(summary);
          summaryParent = footerPanel;
        }
        if (summaryParent && footerPanel && usesFooter) {
          var oldWrap = footerPanel.querySelector('.csy-summary-scroll-wrap');
          if (oldWrap && oldWrap.contains(summary)) {
            footerPanel.insertBefore(summary, oldWrap);
            oldWrap.remove();
          }
        }
        if (summaryParent && !summaryParent.contains(summary)) {
          summaryParent.appendChild(summary);
        } else if (!widget.contains(summary)) {
          widget.appendChild(summary);
        }
        summary.style.position = 'relative';
        summary.style.width = '100%';
        summary.style.maxWidth = '100%';
        summary.style.left = '0';
        summary.style.top = '0';
        summary.style.display = 'block';
        summary.style.zIndex = '1';
        if (usesFooter && widget.classList.contains('csy-has-chart')) {
          summary.style.height = 'auto';
          summary.style.minHeight = '0';
          summary.style.maxHeight = 'none';
          summary.style.overflow = 'visible';
        }
      }

      widget.querySelectorAll('[id^="csy_summary_"], .csy-widget-summary, table').forEach(function(node) {
        node.style.position = 'relative';
        node.style.left = 'auto';
        node.style.top = 'auto';
        node.style.right = 'auto';
        node.style.maxWidth = '100%';
      });

      var canvases = widget.querySelectorAll('canvas');
      for (var c = 0; c < canvases.length; c++) {
        var canvas = canvases[c];
        canvas.style.width = '100%';
        canvas.style.maxWidth = '100%';
        if (canvas.__csyChart && canvas.__csyChart.resize) {
          canvas.__csyChart.resize();
        }
      }

      function stripLoadingText(root) {
        if (!root) {
          return;
        }
        Array.prototype.slice.call(root.childNodes).forEach(function(node) {
          if (node.nodeType === 3 && /^loading/i.test(String(node.textContent || '').trim())) {
            node.textContent = '';
          }
        });
        root.querySelectorAll('.csy-widget-skeleton, .csy-widget-loading-text').forEach(function(el) {
          el.remove();
        });
      }

      var readyCanvas = widget.querySelector('[id^="csy_chart_"]:not([id$="_panel"])');
      var isLoading = widget.getAttribute('data-csy-loading') === '1';
      var widgetLoaded = !!(readyCanvas && readyCanvas.__csyChart) ||
        !!widget.querySelector('.csy-widget-error') ||
        !!widget.querySelector('.csy-chart-empty');
      if (widgetLoaded) {
        widget.setAttribute('data-csy-loaded', '1');
      }
      var widgetLoading = isLoading;
      if (!widgetLoading && widgetLoaded) {
        stripLoadingText(widget);
        widget.querySelectorAll('[id^="csy_chart_"], .card-body-chart, .csy-card-body, .csy-card-footer').forEach(stripLoadingText);
        widget.querySelectorAll('[data-csy-hidden-for-load="1"]').forEach(function(panel) {
          panel.style.visibility = '';
          panel.style.display = '';
          panel.removeAttribute('data-csy-hidden-for-load');
          panel.removeAttribute('aria-hidden');
        });
      }
    }

    var row = (window.SMX && window.SMX.findDashboardWidgetsRow)
      ? window.SMX.findDashboardWidgetsRow()
      : document.getElementById('DashboardWidgetsRow');
    if (!row) {
      row = document.querySelector('.csy-dashboard-page .csy-dashboard-widgets');
    }
    if (!row) {
      row = document.querySelector('#MainPanel .csy-dashboard-widgets');
    }
    if (!row) {
      return;
    }

    row.style.display = 'grid';
    row.style.width = '100%';
    row.style.maxWidth = '100%';
    row.style.minWidth = '0';
    row.style.gap = '1.25rem';
    row.style.alignItems = 'stretch';
    if (window.SMX && window.SMX.syncDashboardGridColumns) {
      window.SMX.syncDashboardGridColumns(row);
    }

    var widgets = document.querySelectorAll('[id^="csy_widget_"]');
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      if (widget.parentElement !== row) {
        row.appendChild(widget);
      }
      finalizeCsyWidget(widget);
    }

    var staleCombos = document.querySelectorAll('[id^="csy_combo_"]');
    for (var sc = 0; sc < staleCombos.length; sc++) {
      staleCombos[sc].remove();
    }

    var mainPanel = document.getElementById('MainPanel');
    if (mainPanel) {
      mainPanel.style.display = 'block';
      mainPanel.style.width = '100%';
    }

    if (window.SMX) {
      var dashboardSelf = this;
      window.SMX._csyOnDashboardOrderChanged = function() {
        if (dashboardSelf && dashboardSelf.ApplyWidgetOrderFromDom) {
          dashboardSelf.ApplyWidgetOrderFromDom();
        }
        if (dashboardSelf && dashboardSelf.ScheduleWidgetOrderSave) {
          dashboardSelf.ScheduleWidgetOrderSave();
        }
      };
      if (window.SMX.setupDashboardWidgetReorder) {
        window.SMX.setupDashboardWidgetReorder(row);
      }

      window.SMX._csyFinalizeDashboardWidget = finalizeCsyWidget;
      if (window.SMX.installDashboardResizeHandler) {
        window.SMX.installDashboardResizeHandler(function() {
          if (dashboardSelf && dashboardSelf.HandleViewportResize) {
            dashboardSelf.HandleViewportResize();
          }
        });
      }
    }
  end;

  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lWidget.ApplyLayoutSettings;
    lWidget.FinalizeChartLayout;
    lWidget.ApplySummaryTableLayout;
    lWidget.LockChartSummaryFooterLayout;
  end;

  asm
    if (window.SMX && window.SMX.enforceDashboardWidgetLayout) {
      window.SMX.enforceDashboardWidgetLayout();
    }
  end;
end;

procedure TDashboard.HandleViewportResize;
var
  lIdx: integer;
  lWidget: TBaseDashboardItem;
begin
  if not Assigned(FDashboardList) or (FDashboardList.Count = 0) then
    Exit;

  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lWidget.ApplyLayoutSettings;
    lWidget.FinalizeChartLayout;
    lWidget.ApplySummaryTableLayout;
    lWidget.LockChartSummaryFooterLayout;
  end;
end;

function TDashboard.GetDashboardParamsString: string;
begin
  if Assigned(FDashboardParams) then
    Result := string(TJSJSON.stringify(FDashboardParams))
  else
    Result := '{}';
end;

procedure TDashboard.ApplyBulkWidgetData(const ABulk: TList<TDashboardBulkItem>);
var
  lIdx: integer;
  lBulkIdx: integer;
  lWidget: TBaseDashboardItem;
  lBulkItem: TDashboardBulkItem;
  lMatched: Boolean;
  lStaged: TArray<Boolean>;
begin
  if not Assigned(ABulk) then
    Exit;

  SetLength(lStaged, FDashboardList.Count);

  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lMatched := False;
    for lBulkIdx := 0 to ABulk.Count - 1 do
    begin
      lBulkItem := ABulk[lBulkIdx];
      if lBulkItem.ItemId = lWidget.DashboardId then
      begin
        lMatched := True;
        try
          lWidget.StageBulkData(lBulkItem.Response);
          lStaged[lIdx] := True;
        except
          lStaged[lIdx] := False;
          lWidget.ShowErrorState;
        end;
        Break;
      end;
    end;
    if not lMatched then
      lStaged[lIdx] := False;
  end;

  await(FlushBrowserPaint);

  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    if lStaged[lIdx] then
    begin
      try
        await(lWidget.PresentBulkData);
      except
        lWidget.ShowErrorState;
      end;
    end
    else
    begin
      lWidget.IndividualFetchReason := 'BulkMissingItem';
      await(lWidget.LoadAndApply);
    end;
  end;
end;

procedure TDashboard.FinalizeBulkWidgetPresentation;
var
  lIdx: integer;
  lWidget: TBaseDashboardItem;
begin
  ApplyTemplateOrderToDom;
  RemoveStaleDashboardWidgets;
  ClearOrphanWidgetSkeletons;

  asm
    if (window.SMX && window.SMX.enforceDashboardWidgetLayout) {
      window.SMX.enforceDashboardWidgetLayout();
    }
  end;

  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lWidget.EnsureChartReadyForRender;
    lWidget.FinalizeChartLayout;
  end;

  asm
    document.querySelectorAll('[id^="csy_widget_"] [data-csy-hidden-for-load]').forEach(function(panel) {
      panel.style.visibility = '';
      panel.style.display = '';
      panel.removeAttribute('data-csy-hidden-for-load');
      panel.removeAttribute('aria-hidden');
    });
    document.querySelectorAll('[id^="csy_widget_"] .card-body-chart, [id^="csy_widget_"] [id^="csy_chart_"]').forEach(function(panel) {
      if (panel.style.display === 'none') {
        panel.style.display = '';
      }
      if (panel.style.visibility === 'hidden') {
        panel.style.visibility = '';
      }
    });
    document.querySelectorAll('[id^="csy_widget_"]:not([data-csy-loading="1"]) canvas').forEach(function(canvas) {
      if (canvas.__csyChart && typeof canvas.__csyChart.resize === 'function') {
        canvas.__csyChart.resize();
      }
    });
  end;
end;

[async]
procedure TDashboard.FlushBrowserPaint; async;
begin
  asm
    await new Promise(function(resolve) {
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(resolve);
      });
    });
  end;
end;

procedure TDashboard.ReloadEmptyChartWidgets;
var
  lIdx: Integer;
  lWidget: TBaseDashboardItem;
begin
  if not Assigned(FDashboardList) then
    Exit;

  // After a successful bulk response, re-present staged widget data locally.
  // Never refetch GetDashboardItem here — that defeats bulk loading.
  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    if lWidget.HasRenderedChart or lWidget.HasDisplayedContent then
      Continue;

    if lWidget.HasChartData(lWidget.GetEffectiveChartJson) then
      await(lWidget.PresentBulkData)
    else if lWidget.RequiresChart then
      lWidget.ShowChartNoData;
  end;
end;

procedure TDashboard.LoadAllWidgetData;
var
  lBulk: TList<TDashboardBulkItem>;
  lIdx: integer;
  lWidget: TBaseDashboardItem;
begin
  ImplementParameters;

  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lWidget.DashboardParameters := GetParameters(lWidget.Configuration.Parameters, lWidget.Title);
  end;
  ShowAllWidgetSkeletons;

  await(FlushBrowserPaint);

  try
    lBulk := Await(SharedData.Dashboard.GetDashboardItemsBulk(
      GetDashboardParamsString, FDashboardItemTemplates));
    try
      // Prefer currency from bulk payload; only call the old endpoint if absent.
      if not SharedData.Dashboard.HasCachedCurrencySymbol then
        await(SharedData.Dashboard.GetDefaultCurrencySymbol);
      await(ApplyBulkWidgetData(lBulk));
      await(ReloadEmptyChartWidgets);
    finally
      lBulk.Free;
    end;
  except
    // Bulk normally carries CurrencySymbol; fallback path still needs the tenant symbol.
    await(SharedData.Dashboard.GetDefaultCurrencySymbol);
    for lIdx := 0 to FDashboardList.Count - 1 do
    begin
      TBaseDashboardItem(FDashboardList.Objects[lIdx]).IndividualFetchReason := 'BulkFallback';
      await(TBaseDashboardItem(FDashboardList.Objects[lIdx]).LoadAndApply);
    end;
  end;

  FinalizeBulkWidgetPresentation;
end;

procedure TDashboard.ShowEmptyDashboardMessage;
begin
  asm
    var row = (window.SMX && window.SMX.findDashboardWidgetsRow)
      ? window.SMX.findDashboardWidgetsRow()
      : document.getElementById('DashboardWidgetsRow');
    if (!row) {
      return;
    }
    if (row.children.length > 0) {
      return;
    }
    row.style.display = 'block';
    row.innerHTML = '<div class="col-12 text-center text-muted py-5">No dashboard metrics are assigned to your account yet. Refresh the page after an administrator has set up your access.</div>';
  end;
end;

procedure TDashboard.CleanupDashboardLoadingState;
begin
  asm
    document.querySelectorAll('[id^="csy_widget_"]').forEach(function(widget) {
      if (widget.getAttribute('data-csy-loading') === '1') {
        return;
      }
      var chartCanvas = widget.querySelector('[id^="csy_chart_"]:not([id$="_panel"])');
      var widgetLoaded = widget.getAttribute('data-csy-loaded') === '1' ||
        !!(chartCanvas && chartCanvas.__csyChart) ||
        !!widget.querySelector('.csy-widget-error') ||
        !!widget.querySelector('.csy-chart-empty');
      if (!widgetLoaded) {
        return;
      }
      widget.querySelectorAll('[data-csy-hidden-for-load="1"]').forEach(function(panel) {
        panel.style.visibility = '';
        panel.style.display = '';
        panel.removeAttribute('data-csy-hidden-for-load');
        panel.removeAttribute('aria-hidden');
      });
      widget.querySelectorAll('[id^="csy_loading_"]').forEach(function(loading) {
        loading.style.display = 'none';
      });
    });
  end;
end;

function TDashboard.CreateDashboardItemInstance(ADashBoardItemTemplate: TDashboardItemTemplate): TBaseDashboardItem;
var
  lDashboardItem: TBaseDashboardItem;
  lParameters: string;
  lItemType: string;
begin
  Result := nil;
  if not Assigned(ADashBoardItemTemplate) then
    Exit;

  lItemType := Trim(ADashBoardItemTemplate.DashboardItemType);
  if not TDashboardItemFactory.IsKnownType(lItemType) then
  begin
    console.log('Unknown dashboard item type: ' + lItemType);
    MainPage.ShowAToast('Dashboard',
      'Unknown widget type: ' + lItemType,
      'fad fa-exclamation-triangle');
    Exit;
  end;

  try
    lDashboardItem := TDashboardItemFactory.CreateInstance(lItemType, Self);
    if not Assigned(lDashboardItem) then
      Exit;

    lDashboardItem.DashboardId := ADashBoardItemTemplate.Id;
    lDashboardItem.ElementID := 'csy_widget_' + IntToStr(ADashBoardItemTemplate.Id);
    lDashboardItem.Parent := WidgetHostPanel;
    lDashboardItem.Left := 0;
    lDashboardItem.Top := 0;
    lDashboardItem.HeightStyle := ssAuto;
    lDashboardItem.WidthPercent := 100;
    lDashboardItem.Template := ADashBoardItemTemplate;
    lDashboardItem.PrepareShell(ADashboardItemTemplate.Title);
    if Assigned(lDashboardItem.Configuration) then
      lParameters := GetParameters(lDashboardItem.Configuration.Parameters, ADashboardItemTemplate.Title)
    else
      lParameters := '{}';
    lDashboardItem.DashboardParameters := lParameters;
    lDashboardItem.ApplyLayoutSettings;

    Result := lDashboardItem;
  except
    on E: Exception do
    begin
      console.log('CreateDashboardItemInstance failed: ' + E.Message);
      MainPage.ShowAToast('Dashboard',
        'Failed to create widget: ' + ADashboardItemTemplate.Title,
        'fad fa-exclamation-triangle');
      Result := nil;
    end;
  end;
end;

procedure TDashboard.RefreshButtonClick(Sender: TObject);
begin
  await(RefreshDashboard(0));
end;

procedure TDashboard.RefreshDashboard(ADashboardId: integer);
begin
  InvalidateDashboardDataCache;
  RefreshButton.Enabled := False;
  try
    await(LoadAllWidgetData);
  finally
    RefreshButton.Enabled := True;
  end;
end;

procedure TDashboard.ShowDashboardLoading(AVisible: Boolean);
begin
  if AVisible then
  begin
    asm
      var bar = document.getElementById('DashboardLoadingBar');
      if (bar) {
        bar.classList.remove('d-none');
      }
    end;
  end
  else
  begin
    asm
      var bar = document.getElementById('DashboardLoadingBar');
      if (bar) {
        bar.classList.add('d-none');
      }
    end;
    ClearOrphanWidgetSkeletons;
  end;
end;

procedure TDashboard.ClearOrphanWidgetSkeletons;
  begin
  asm
    document.querySelectorAll('[id^="csy_widget_"]').forEach(function(widget) {
      if (widget.getAttribute('data-csy-loading') === '1') {
        return;
      }
      var chartCanvas = widget.querySelector('[id^="csy_chart_"]:not([id$="_panel"])');
      var widgetLoaded = widget.getAttribute('data-csy-loaded') === '1' ||
        !!(chartCanvas && chartCanvas.__csyChart) ||
        !!widget.querySelector('.csy-widget-error') ||
        !!widget.querySelector('.csy-chart-empty');
      if (!widgetLoaded) {
        return;
      }
      widget.querySelectorAll('[data-csy-hidden-for-load="1"]').forEach(function(panel) {
        panel.style.visibility = '';
        panel.style.display = '';
        panel.removeAttribute('data-csy-hidden-for-load');
        panel.removeAttribute('aria-hidden');
      });
    });

  end;
end;

procedure TDashboard.RemoveStaleDashboardWidgets;
var
  lIdx: Integer;
  lValidIds: string;
  lWidget: TBaseDashboardItem;
begin
  lValidIds := '';
  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    if lValidIds <> '' then
      lValidIds := lValidIds + ',';
    lValidIds := lValidIds + lWidget.ElementID;
  end;

  asm
    var validRaw = lValidIds || '';
    var valid = validRaw ? validRaw.split(',') : [];
    var row = (window.SMX && window.SMX.findDashboardWidgetsRow)
      ? window.SMX.findDashboardWidgetsRow()
      : document.getElementById('DashboardWidgetsRow');
    if (!row) {
      return;
    }
    Array.prototype.slice.call(row.querySelectorAll('[id^="csy_widget_"]')).forEach(function(node) {
      if (valid.indexOf(node.id) < 0) {
        node.remove();
      }
    });
  end;
end;

procedure TDashboard.RefreshDashboardItemsTimerTimer(Sender: TObject);
begin
  RefreshDashboardItemsTimer.Enabled := False;
  await(RefreshDashboardItems);
end;

procedure TDashboard.RefreshDashboardItems;
var
  lIdx: integer;
  lCount: integer;
  lDashboardItem: TBaseDashboardItem;
begin
  CancelPendingWidgetOrderSave;

  lCount := FDashboardList.Count;

  for lIdx := lCount-1 downto 0 do
  begin
    lDashboardItem := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    lDashboardItem.Free;
  end;
  FDashboardList.Clear;

  if Assigned(FDashboardItemTemplates) then
  begin
    FDashboardItemTemplates.Clear;
    FDashboardItemTemplates.Free;
    FDashboardItemTemplates := nil;
  end;

  if FUserId <> 0 then
  begin
    FDashboardItemTemplates := Await(SharedData.Dashboard.GetDashboardItemTemplates(FUserId));
  end;

  ImplementParameters;
  CreateDashboardShells;
  CaptureWidgetOrderSignature;
  await(LoadAllWidgetData);
  CaptureWidgetOrderSignature;
end;

procedure TDashboard.ApplyDashboardOrderToItemTitles(AList: TList<TDashboardItemTitle>);
var
  lOrderStr: string;
  lParts: TArray<string>;
  lIdx: Integer;
  lItemIdx: Integer;
  lOrder: Integer;
  lItemId: Integer;
  lItem: TDashboardItemTitle;
  lUsed: TDictionary<Integer, Boolean>;
begin
  if not Assigned(AList) then
    Exit;

  asm
    lOrderStr = (window.SMX && window.SMX.collectDashboardWidgetOrderIds)
      ? window.SMX.collectDashboardWidgetOrderIds()
      : '';
  end;

  lUsed := TDictionary<Integer, Boolean>.Create;
  try
    lOrder := 0;
    if lOrderStr <> '' then
    begin
      lParts := lOrderStr.Split([',']);
      for lIdx := 0 to High(lParts) do
      begin
        lItemId := StrToIntDef(Trim(lParts[lIdx]), 0);
        if lItemId <= 0 then
          Continue;

        for lItemIdx := 0 to AList.Count - 1 do
        begin
          lItem := AList[lItemIdx];
          if lItem.Selected and (lItem.Id = lItemId) and not lUsed.ContainsKey(lItemId) then
          begin
            Inc(lOrder);
            lItem.OrderIndex := lOrder;
            lUsed.Add(lItemId, True);
            Break;
          end;
        end;
      end;
    end;

    for lItemIdx := 0 to AList.Count - 1 do
    begin
      lItem := AList[lItemIdx];
      if not lItem.Selected or lUsed.ContainsKey(lItem.Id) then
        Continue;
      Inc(lOrder);
      lItem.OrderIndex := lOrder;
      lUsed.Add(lItem.Id, True);
    end;
  finally
    lUsed.Free;
  end;
end;

procedure TDashboard.ApplyTemplateOrderToDom;
var
  lIdx: Integer;
  lOrderStr: string;
begin
  if not Assigned(FDashboardItemTemplates) or (FDashboardItemTemplates.Count = 0) then
    Exit;

  lOrderStr := '';
  for lIdx := 0 to FDashboardItemTemplates.Count - 1 do
  begin
    if lOrderStr <> '' then
      lOrderStr := lOrderStr + ',';
    lOrderStr := lOrderStr + IntToStr(FDashboardItemTemplates[lIdx].Id);
  end;

  asm
    var row = (window.SMX && window.SMX.findDashboardWidgetsRow)
      ? window.SMX.findDashboardWidgetsRow()
      : document.getElementById('DashboardWidgetsRow');
    if (row && lOrderStr && window.SMX.applyDashboardWidgetOrder) {
      window.SMX.applyDashboardWidgetOrder(row, lOrderStr);
    }
  end;
end;

procedure TDashboard.CancelPendingWidgetOrderSave;
begin
  WidgetOrderSaveTimer.Enabled := False;
end;

function TDashboard.IsDashboardItemSelected(ADashboardItemId: Integer): Boolean;
var
  lIdx: Integer;
  lItem: TDashboardItemTitle;
begin
  if not Assigned(FDashboardItemTitles) then
    Exit(True);

  for lIdx := 0 to FDashboardItemTitles.Count - 1 do
  begin
    lItem := FDashboardItemTitles[lIdx];
    if lItem.Id = ADashboardItemId then
      Exit(lItem.Selected);
  end;

  Result := False;
end;

procedure TDashboard.ScheduleWidgetOrderSave;
begin
  if not FDashboardReady or FSuppressWidgetOrderSave then
    Exit;
  WidgetOrderSaveTimer.Enabled := False;
  WidgetOrderSaveTimer.Enabled := True;
end;

procedure TDashboard.ApplyWidgetOrderFromDom;
var
  lOrderStr: string;
  lParts: TArray<string>;
  lIdx: Integer;
  lCount: Integer;
  lItemId: Integer;
  lChildOrder: Integer;
  lWidget: TBaseDashboardItem;
  lOrderedIds: TArray<Integer>;
begin
  asm
    lOrderStr = (window.SMX && window.SMX.collectDashboardWidgetOrderIds)
      ? window.SMX.collectDashboardWidgetOrderIds()
      : '';
  end;

  if lOrderStr = '' then
    Exit;

  lParts := lOrderStr.Split([',']);
  lCount := 0;
  SetLength(lOrderedIds, 0);
  for lIdx := 0 to High(lParts) do
  begin
    lItemId := StrToIntDef(Trim(lParts[lIdx]), 0);
    if lItemId <= 0 then
      Continue;
    SetLength(lOrderedIds, lCount + 1);
    lOrderedIds[lCount] := lItemId;
    Inc(lCount);
  end;

  if lCount = 0 then
    Exit;

  lChildOrder := 0;
  for lIdx := 0 to High(lOrderedIds) do
  begin
    lWidget := FindWidgetByDashboardItemId(lOrderedIds[lIdx]);
    if Assigned(lWidget) then
    begin
      lWidget.ChildOrder := lChildOrder;
      Inc(lChildOrder);
    end;
  end;

  SyncListsToWidgetOrder(lOrderedIds);
end;

procedure TDashboard.WidgetOrderSaveTimerTimer(Sender: TObject);
begin
  WidgetOrderSaveTimer.Enabled := False;
  await(SaveDashboardWidgetOrder);
end;

procedure TDashboard.CaptureWidgetOrderSignature;
var
  lOrderStr: string;
begin
  asm
    lOrderStr = (window.SMX && window.SMX.collectDashboardWidgetOrderIds)
      ? window.SMX.collectDashboardWidgetOrderIds()
      : '';
  end;
  FLastSavedWidgetOrder := lOrderStr;
end;

function TDashboard.FindWidgetByDashboardItemId(ADashboardItemId: Integer): TBaseDashboardItem;
var
  lIdx: Integer;
  lWidget: TBaseDashboardItem;
begin
  Result := nil;
  for lIdx := 0 to FDashboardList.Count - 1 do
  begin
    lWidget := TBaseDashboardItem(FDashboardList.Objects[lIdx]);
    if lWidget.DashboardId = ADashboardItemId then
      Exit(lWidget);
  end;
end;

function TDashboard.FindDashboardItemTitleById(ADashboardItemId: Integer): TDashboardItemTitle;
var
  lIdx: Integer;
  lItem: TDashboardItemTitle;
begin
  Result := nil;
  if not Assigned(FDashboardItemTitles) then
    Exit;
  for lIdx := 0 to FDashboardItemTitles.Count - 1 do
  begin
    lItem := TDashboardItemTitle(FDashboardItemTitles[lIdx]);
    if lItem.Id = ADashboardItemId then
      Exit(lItem);
  end;
end;

function TDashboard.FindTemplateById(ADashboardItemId: Integer): TDashboardItemTemplate;
var
  lIdx: Integer;
begin
  Result := nil;
  if not Assigned(FDashboardItemTemplates) then
    Exit;
  for lIdx := 0 to FDashboardItemTemplates.Count - 1 do
    if FDashboardItemTemplates[lIdx].Id = ADashboardItemId then
      Exit(FDashboardItemTemplates[lIdx]);
end;

procedure TDashboard.SyncListsToWidgetOrder(const AOrderedIds: TArray<Integer>);
var
  lNewList: TStringList;
  lNewTemplates: TList<TDashboardItemTemplate>;
  lIdx: Integer;
  lWidget: TBaseDashboardItem;
  lTemplate: TDashboardItemTemplate;
begin
  lNewList := TStringList.Create;
  lNewTemplates := TList<TDashboardItemTemplate>.Create;
  try
    for lIdx := 0 to High(AOrderedIds) do
    begin
      lWidget := FindWidgetByDashboardItemId(AOrderedIds[lIdx]);
      if Assigned(lWidget) then
        lNewList.AddObject(lWidget.Title, lWidget);
      lTemplate := FindTemplateById(AOrderedIds[lIdx]);
      if Assigned(lTemplate) then
        lNewTemplates.Add(lTemplate);
    end;

    if lNewList.Count > 0 then
    begin
      FDashboardList.Free;
      FDashboardList := lNewList;
      lNewList := nil;
    end;

    if lNewTemplates.Count > 0 then
    begin
      FDashboardItemTemplates.Free;
      FDashboardItemTemplates := lNewTemplates;
      lNewTemplates := nil;
    end;
  finally
    if Assigned(lNewList) then
      lNewList.Free;
    if Assigned(lNewTemplates) then
      lNewTemplates.Free;
  end;
end;

procedure TDashboard.SaveDashboardWidgetOrder;
var
  lOrderStr: string;
  lParts: TArray<string>;
  lIdx: Integer;
  lCount: Integer;
  lTitleIdx: Integer;
  lItemId: Integer;
  lOrder: Integer;
  lWidget: TBaseDashboardItem;
  lItems: TList<TDashboardItemTitle>;
  lItem: TDashboardItemTitle;
  lOrderedIds: TArray<Integer>;
  lSavedIds: TArray<Integer>;
  lOldItem: TDashboardItemTitle;
  lTitleItem: TDashboardItemTitle;

  function ItemAlreadySaved(AItemId: Integer): Boolean;
  var
    lCheckIdx: Integer;
  begin
    Result := False;
    for lCheckIdx := 0 to lItems.Count - 1 do
      if lItems[lCheckIdx].Id = AItemId then
        Exit(True);
  end;

  procedure AppendSelectedItem(AItemId: Integer);
  var
    lNewItem: TDashboardItemTitle;
  begin
    if AItemId <= 0 then
      Exit;
    if not IsDashboardItemSelected(AItemId) then
      Exit;
    if ItemAlreadySaved(AItemId) then
      Exit;

    Inc(lOrder);
    lNewItem := TDashboardItemTitle.Create;
    lNewItem.Id := AItemId;
    lNewItem.Selected := True;
    lNewItem.OrderIndex := lOrder;

    lWidget := FindWidgetByDashboardItemId(AItemId);
    if Assigned(lWidget) then
      lNewItem.Title := lWidget.Title
    else
    begin
      lTitleItem := FindDashboardItemTitleById(AItemId);
      if Assigned(lTitleItem) then
        lNewItem.Title := lTitleItem.Title
      else
      begin
        lNewItem.Free;
        Dec(lOrder);
        Exit;
      end;
    end;

    lItems.Add(lNewItem);
  end;

begin
  if FUserId = 0 then
    Exit;

  asm
    lOrderStr = (window.SMX && window.SMX.collectDashboardWidgetOrderIds)
      ? window.SMX.collectDashboardWidgetOrderIds()
      : '';
  end;

  if lOrderStr = FLastSavedWidgetOrder then
    Exit;

  lParts := lOrderStr.Split([',']);
  lCount := 0;
  SetLength(lOrderedIds, 0);
  for lIdx := 0 to High(lParts) do
  begin
    lItemId := StrToIntDef(Trim(lParts[lIdx]), 0);
    if lItemId <= 0 then
      Continue;
    SetLength(lOrderedIds, lCount + 1);
    lOrderedIds[lCount] := lItemId;
    Inc(lCount);
  end;

  if lCount = 0 then
    Exit;

  lItems := TList<TDashboardItemTitle>.Create;
  try
    lOrder := 0;
    for lIdx := 0 to High(lOrderedIds) do
      AppendSelectedItem(lOrderedIds[lIdx]);

    if Assigned(FDashboardItemTitles) then
    begin
      for lTitleIdx := 0 to FDashboardItemTitles.Count - 1 do
      begin
        lOldItem := TDashboardItemTitle(FDashboardItemTitles[lTitleIdx]);
        if not lOldItem.Selected then
          Continue;
        AppendSelectedItem(lOldItem.Id);
      end;
    end;

    if lItems.Count = 0 then
      Exit;

    SetLength(lSavedIds, lItems.Count);
    for lIdx := 0 to lItems.Count - 1 do
      lSavedIds[lIdx] := lItems[lIdx].Id;

    await(SharedData.Dashboard.SaveUserDashboardItemTitles(FUserId, lItems));

    if Assigned(FDashboardItemTitles) then
    begin
      for lTitleIdx := 0 to FDashboardItemTitles.Count - 1 do
      begin
        lOldItem := TDashboardItemTitle(FDashboardItemTitles[lTitleIdx]);
        lOldItem.OrderIndex := 0;
        lOldItem.Selected := False;
      end;
      for lIdx := 0 to lItems.Count - 1 do
      begin
        lItem := lItems[lIdx];
        for lTitleIdx := 0 to FDashboardItemTitles.Count - 1 do
        begin
          lOldItem := TDashboardItemTitle(FDashboardItemTitles[lTitleIdx]);
          if lOldItem.Id = lItem.Id then
          begin
            lOldItem.OrderIndex := lItem.OrderIndex;
            lOldItem.Selected := True;
            Break;
          end;
        end;
      end;
    end
    else
    begin
      FDashboardItemTitles := lItems;
      lItems := nil;
    end;

    SyncListsToWidgetOrder(lSavedIds);

    lOrderStr := '';
    for lIdx := 0 to High(lSavedIds) do
    begin
      if lOrderStr <> '' then
        lOrderStr := lOrderStr + ',';
      lOrderStr := lOrderStr + IntToStr(lSavedIds[lIdx]);
    end;
    FLastSavedWidgetOrder := lOrderStr;
  finally
    if Assigned(lItems) then
    begin
      for lIdx := 0 to lItems.Count - 1 do
      begin
        lOldItem := TDashboardItemTitle(lItems[lIdx]);
        lOldItem.Free;
      end;
      lItems.Free;
    end;
  end;
end;

procedure TDashboard.WebFormShow(Sender: TObject);
begin
  Dashboard := Self;
  BranchTreeView.Visible := False;
  WaitMessage.Hide;
  asm
    var panel = document.getElementById('MainPanel');
    if (panel) {
      panel.style.width = '100%';
      panel.style.maxWidth = '100%';
    }
    var form = document.getElementById(this.ElementID);
    if (form) {
      form.style.width = '100%';
      form.style.maxWidth = '100%';
    }
    var row = (window.SMX && window.SMX.findDashboardWidgetsRow)
      ? window.SMX.findDashboardWidgetsRow()
      : document.getElementById('DashboardWidgetsRow');
    if (row) {
      row.style.width = '100%';
      row.style.maxWidth = '100%';
      row.style.minWidth = '0';
      if (window.SMX && window.SMX.syncDashboardGridColumns) {
        window.SMX.syncDashboardGridColumns(row);
      }
    }
  end;
  InitialiseDashboard;
  asm
    if (window.SMX && window.SMX.enforceDashboardWidgetLayout) {
      window.setTimeout(function() {
        window.SMX.enforceDashboardWidgetLayout();
      }, 0);
      window.setTimeout(function() {
        window.SMX.enforceDashboardWidgetLayout();
      }, 300);
    }
  end;
end;

procedure TDashboard.SetLocalDefaultDateRange;
begin
  EndDatePicker.DateTime := Date;
  StartDatePicker.Date := Date - 7;
end;

procedure TDashboard.ApplyDefaultDateRange;
var
  lLatestIso: string;
  lLatestDate: TDateTime;
  lYear, lMonth, lDay: Word;
  lApplied: Boolean;
begin
  lApplied := False;
  FSuppressDateRefresh := True;
  try
    try
      lLatestIso := Await(SharedData.Dashboard.GetLatestTransactionDate);

      if (Length(lLatestIso) >= 10) then
      begin
        lYear := StrToIntDef(Copy(lLatestIso, 1, 4), 0);
        lMonth := StrToIntDef(Copy(lLatestIso, 6, 2), 0);
        lDay := StrToIntDef(Copy(lLatestIso, 9, 2), 0);

        if (lYear > 0) and (lMonth > 0) and (lDay > 0) then
        begin
          lLatestDate := EncodeDate(lYear, lMonth, lDay);
          EndDatePicker.DateTime := lLatestDate;
          StartDatePicker.Date := lLatestDate - 7;
          lApplied := True;
        end;
      end;
    except
    end;
  finally
    FSuppressDateRefresh := False;
  end;

  if not lApplied then
  begin
    FSuppressDateRefresh := True;
    try
      SetLocalDefaultDateRange;
    finally
      FSuppressDateRefresh := False;
    end;
  end;
end;

procedure TDashboard.BranchTreeViewChange(Sender: TObject; Node: TTreeNode);
begin
  UpdateBranchIdsList;
end;

procedure TDashboard.ChartTimerTimer(Sender: TObject);
var
  lIdx: integer;
begin
  ChartTimer.Enabled := False;
end;

procedure TDashboard.ConfigurationButtonClick(Sender: TObject);
begin
  // Guard in case the hidden button is still invoked somehow
  if not ConfigurationButton.Visible then
    Exit;
  ConfigurationPopUp;
end;

procedure TDashboard.ConfigurationPopUp;
var
  ConfigForm: TConfigurationForm;
  lStructure: string;
begin
  CancelPendingWidgetOrderSave;
  FSuppressWidgetOrderSave := True;
  ConfigForm := TConfigurationForm.Create(Self);
  try
    ConfigForm.Popup := True;
    ConfigForm.PopupOpacity := 1;
    await(TConfigurationForm, ConfigForm.Load());

    await(RefreshBranchAccessMetadata);

    await(GetTenantDashboardItems);

    FUserConfig := Await(SharedData.Dashboard.GetUserConfig(FUserId));

    // Explicit Branch / BranchGroup assignment always limits the tree — even for admins.
    if HasExplicitBranchScope then
      lStructure := FilterBranchStructureForUser(FBranchStructureJSON)
    else if AuthService.IsAdministrator or UserHasUnrestrictedBranches then
      lStructure := FBranchStructureJSON
    else
      lStructure := FilterBranchStructureForUser(FBranchStructureJSON);

    ConfigForm.UserBranchList := ParseBranchListFromUserConfigJson(FUserConfig.Config);
    if (Length(ConfigForm.UserBranchList) = 0) and (Trim(FUserConfig.Config) = '') then
      ConfigForm.UserBranchList := BranchIdsCsvToArray(ResolveEffectiveBranchIds);

    FWebUserConfiguration.BranchList := ConfigForm.UserBranchList;
    ClampBranchListToUserAccess;
    ConfigForm.UserBranchList := FWebUserConfiguration.BranchList;
    ConfigForm.BranchStructure := lStructure;
    ConfigForm.SetDashboardMetrics(FDashboardItemTitles);

    await(TModalResult, ConfigForm.Execute);

    if ConfigForm.ModalResult = mrOk then
    begin
      CancelPendingWidgetOrderSave;
      FWebUserConfiguration.BranchList := ConfigForm.UserBranchList;
      ClampBranchListToUserAccess;
      if not Await(SetUserConfiguration) then
        Exit;

      FDashboardItemTitles := ConfigForm.ExtractSavedDashboardItemTitles;
      await(SaveUserDashboardItems(FDashboardItemTitles));

      InvalidateDashboardDataCache;
      ImplementParameters;
      await(RefreshDashboardItems);
      CaptureWidgetOrderSignature;
    end;
  finally
    FSuppressWidgetOrderSave := False;
    ConfigForm.Free;
  end;
end;

procedure TDashboard.GetBranchIdsList;
begin

end;

procedure TDashboard.GetBranchStructure;
begin
  FBranchStructureJSON := Await(SharedData.Dashboard.GetBranchStructure());
  //lRegionArray := JS.toArray(TJSJSON.parse(lBranchStructure));
end;

procedure TDashboard.GetDashboardItemList;
begin

end;

procedure TDashboard.GetSelectedBranches;
var
  lCount: integer;
  lIdx: integer;
  lNode : TTreeNode;
begin
// lCount := BranchTreeView.SelectionCount;

//  lNode := BranchTreeView.Selections[0];

//  BranchTreeView.Subselect()

//  for lIdx := 0 to lCount-1 do
//  begin

//    ListBox.Items.Add(lNode.Text);
//  end;
end;

procedure TDashboard.ImplementParameters;
var
  lParamsInput: TDashboardParamsInput;
begin
  if not Assigned(FWebUserConfiguration) then
    EnsureDefaultWebUserConfiguration;

  lParamsInput.BranchIdList := ResolveEffectiveBranchIds;
  lParamsInput.StartDate := StartDatePicker.Date;
  lParamsInput.EndDate := EndDatePicker.Date;
  lParamsInput.WeekStartDay := FStartDayOfWeek;

  FDashboardParams := TDashboardParamsBuilder.Build(lParamsInput);

  StartDatePicker.Visible := true;
  EndDatePicker.Visible := true;
end;

function TDashboard.CountAssignedBranches: Integer;
var
  lSource: string;
  lIdx: Integer;
  lBranchId: string;
  lIds: string;
begin
  Result := 0;
  lSource := Trim(FUserBranchIds);
  if (lSource = '') or SameText(lSource, '0') then
    Exit;

  lIds := '';
  lIdx := 1;
  while lIdx <= Length(lSource) do
  begin
    lBranchId := '';
    while (lIdx <= Length(lSource)) and (lSource[lIdx] <> ',') do
    begin
      lBranchId := lBranchId + lSource[lIdx];
      Inc(lIdx);
    end;
    Inc(lIdx);
    lBranchId := NormalizeBranchId(lBranchId);
    if (lBranchId <> '') and (Pos(',' + lBranchId + ',', ',' + lIds + ',') = 0) then
    begin
      if lIds <> '' then
        lIds := lIds + ',';
      lIds := lIds + lBranchId;
      Inc(Result);
    end;
  end;
end;

function TDashboard.UserHasUnrestrictedBranches: Boolean;
var
  lSource: string;
  lAll: string;
  lAssignedCount: Integer;
  lAllCount: Integer;
  lIdx: Integer;
  lBranchType: TBranchIdType;
begin
  lBranchType := MainData.BranchIdType;

  // Explicit single branch / branch-group assignment is never "All"
  if lBranchType in [TBranchIdType.Branch, TBranchIdType.BranchGroup] then
    Exit(False);

  lSource := Trim(FUserBranchIds);
  // Only treat empty/'0' as unrestricted when branch type is All/NotSpecified
  if (lBranchType = TBranchIdType.NotSpecified) and
     ((lSource = '') or SameText(lSource, '0')) then
    Exit(True);

  if (lSource = '') or SameText(lSource, '0') then
    Exit(False);

  lAll := CollectAllBranchIdsFromStructure;
  if lAll = '' then
    Exit(False);

  lAssignedCount := CountAssignedBranches;
  lAllCount := 0;
  lIdx := 1;
  while lIdx <= Length(lAll) do
  begin
    while (lIdx <= Length(lAll)) and (lAll[lIdx] <> ',') do
      Inc(lIdx);
    Inc(lAllCount);
    Inc(lIdx);
  end;

  // Assigned set covers every tenant branch => treat as All
  Result := (lAllCount > 1) and (lAssignedCount >= lAllCount);
end;

procedure TDashboard.UpdateConfigurationButtonVisibility;
begin
  ConfigurationButton.Visible := True;
  asm
    var btn = document.getElementById('Configuration');
    if (btn) {
      btn.classList.remove('csy-config-hidden');
      btn.removeAttribute('hidden');
      btn.style.display = '';
    }
  end;
end;

procedure TDashboard.EnsureDefaultWebUserConfiguration;
begin
  FWebUserConfiguration := TUserConfiguration.Create(TJSObject.new);
  FWebUserConfiguration.WeekStartDay := 0;
  SetLength(FWebUserConfiguration.BranchList, 0);
end;

procedure TDashboard.GetUserConfiguration;
var
  lUserConfig: TUserConfig;
  lConfigObj: JS.TJSObject;
  lConfigJSON: string;
begin
  lUserConfig := Await(SharedData.Dashboard.GetUserConfig(FUserId));

  FUserConfig := lUserConfig;

  lConfigJSON := Trim(FUserConfig.Config);
  if lConfigJSON = '' then
    EnsureDefaultWebUserConfiguration
  else
  begin
    try
      lConfigObj := JS.toObject(TJSJSON.parse(lConfigJSON));
      FWebUserConfiguration := TUserConfiguration.Create(lConfigObj);
    except
      EnsureDefaultWebUserConfiguration;
    end;
  end;

  if not Assigned(FWebUserConfiguration) then
    EnsureDefaultWebUserConfiguration;

  if (Length(FWebUserConfiguration.BranchList) = 0) and (Trim(FUserConfig.Config) <> '') then
    FWebUserConfiguration.BranchList := ParseBranchListFromUserConfigJson(FUserConfig.Config);
end;

function TDashboard.SetUserConfiguration: Boolean;
var
  lConfigObj: JS.TJSObject;
  lWebUserConfigStr: string;
  lSavedBranchList: TArray<string>;
  lSavedWeekStartDay: Integer;
  lParsedBranches: TArray<string>;
  lIntendedBranches: TArray<string>;
  lSaveSucceeded: Boolean;
begin
  Result := False;
  if not Assigned(FWebUserConfiguration) then
    Exit;

  lSavedBranchList := FWebUserConfiguration.BranchList;
  lSavedWeekStartDay := FWebUserConfiguration.WeekStartDay;
  lIntendedBranches := lSavedBranchList;

  lConfigObj := FWebUserConfiguration.ToJSONObject;
  lWebUserConfigStr := string(TJSJSON.stringify(lConfigObj));
  FUserConfig.Config := lWebUserConfigStr;

  lSaveSucceeded := Await(SharedData.Dashboard.SetUserConfig(FUserId, FUserConfig.Id, lWebUserConfigStr));

  FUserConfig := Await(SharedData.Dashboard.GetUserConfig(FUserId));
  lParsedBranches := ParseBranchListFromUserConfigJson(FUserConfig.Config);
  if BranchListsMatch(lIntendedBranches, lParsedBranches) then
    lSaveSucceeded := True;

  if not lSaveSucceeded then
  begin
    ReloadPersistedBranchListFromUserConfig;
    asm
      window.alert('Branch configuration was not saved on the server. Rebuild and restart SphinxAuth, then try again.');
    end;
    Exit;
  end;

  if Trim(FUserConfig.Config) <> '' then
  begin
    try
      FWebUserConfiguration := TUserConfiguration.Create(
        JS.toObject(TJSJSON.parse(Trim(FUserConfig.Config))));
    except
    end;
  end;

  if not Assigned(FWebUserConfiguration) then
    EnsureDefaultWebUserConfiguration;

  if Length(lParsedBranches) > 0 then
    FWebUserConfiguration.BranchList := lParsedBranches
  else if (Length(FWebUserConfiguration.BranchList) = 0) and (Length(lSavedBranchList) > 0) then
    FWebUserConfiguration.BranchList := lSavedBranchList;

  if (FWebUserConfiguration.WeekStartDay = 0) and (lSavedWeekStartDay <> 0) then
    FWebUserConfiguration.WeekStartDay := lSavedWeekStartDay;

  Result := True;
end;

function TDashboard.BranchListsMatch(const ALeft, ARight: TArray<string>): Boolean;
var
  lLeftIdx: Integer;
  lRightIdx: Integer;
  lId: string;
  lFound: Boolean;
begin
  if Length(ALeft) <> Length(ARight) then
    Exit(False);

  for lLeftIdx := 0 to High(ALeft) do
  begin
    lId := NormalizeBranchId(ALeft[lLeftIdx]);
    if lId = '' then
      Continue;
    lFound := False;
    for lRightIdx := 0 to High(ARight) do
      if NormalizeBranchId(ARight[lRightIdx]) = lId then
      begin
        lFound := True;
        Break;
      end;
    if not lFound then
      Exit(False);
  end;

  Result := True;
end;

procedure TDashboard.GetBranches;
var
  lBranchStructure: string;
  BranchNode, SN: TTreeNode;
  lIdx: integer;
  lIdx2: integer;
  lRegionArray: JS.TJSArray;
  lGroupArray: JS.TJSArray;
  lRegionName: string;
  lBranchObj: JS.TJSObject;
  lBranchName: string;
  lBranchId: string;
  lSubBranch: TStringList;
begin
  FGroupList := TStringList.Create;
  FBranchList := TStringList.Create;

  lBranchStructure := Await(SharedData.Dashboard.GetBranchStructure());
  FBranchStructureJSON := lBranchStructure;
  if Trim(lBranchStructure) = '' then
    Exit;

  try
  lRegionArray := JS.toArray(TJSJSON.parse(lBranchStructure));
  except
    Exit;
  end;

  BranchTreeView.BeginUpdate;
  try
    for lIdx := 0 to lRegionArray.Length - 1 do
  begin
    lSubBranch := TStringList.Create;
      lGroupArray := JS.toArray(lRegionArray[lIdx]);
      if lGroupArray.Length = 0 then
      begin
        lSubBranch.Free;
        Continue;
      end;

      lRegionName := Trim(String(lGroupArray[0]));
      if lRegionName = '' then
        lRegionName := 'Ungrouped';

      BranchNode := BranchTreeView.Items.Add(lRegionName);
    FGroupList.AddObject(lRegionName, BranchNode);
    FBranchList.AddObject(lRegionName, lSubBranch);
    BranchNode.NodeType := ntCheckBox;

      for lIdx2 := 1 to lGroupArray.Length - 1 do
    begin
        lBranchObj := JS.toObject(lGroupArray[lIdx2]);
        lBranchName := Trim(String(lBranchObj['BranchName']));
        lBranchId := Trim(String(lBranchObj['BranchId']));
        if (lBranchName = '') or (lBranchId = '') then
          Continue;

      SN := BranchTreeView.Items.AddChild(BranchNode, lBranchName);
      SN.NodeType := ntCheckBox;
        SN.Checked := False;
      lSubBranch.AddObject(lBranchId, SN);
    end;
  end;
  finally
  BranchTreeView.EndUpdate;
  end;
end;

procedure TDashboard.UpdateBranchIdsList;
(*var
  lGroupIdx: integer;
  lBranchIdx: integer;
  lGroupNode: TTreeNode;
  lBranchNode: TTreeNode;
  lChecked: boolean;
  lBranchList: TStringList;*)
begin
(*
//  BranchTreeView.BeginUpdate;
  FBranchListForQuery.Clear;
  for lGroupIdx := 0 to FGroupList.Count-1 do
  begin
    lBranchList := TStringList(FBranchList.Objects[lGroupIdx]);
    lGroupNode := TTreeNode(FGroupList.Objects[lGroupIdx]);
    //lChecked := lGroupNode.Checked;

    for lBranchIdx := 0 to lBranchList.Count-1 do
    begin
      lBranchNode := TTreeNode(lBranchList.Objects[lBranchIdx]);
      //lBranchNode.Checked := lChecked;

      if lBranchNode.Checked then
      begin
        //ListBox.Items.Add(lBranchList[lBranchIdx]);
        FBranchListForQuery.Add(lBranchList[lBranchIdx]);
      end;
    end;
  end;
//  BranchTreeView.EndUpdate;*)
end;

procedure TDashboard.UpdateDashboardItemsParameters;
var
  lDashboardItem: TBaseDashboardItem;
  lIndex: Integer;
begin
  for lIndex := 0 to FDashboardList.Count-1 do
  begin
    lDashboardItem := TBaseDashboardItem(FDashboardList.Objects[lIndex]);
  end;
end;

procedure TDashboard.BranchUpdate;
begin

end;


function TDashboard.NormalizeBranchId(const ABranchId: string): string;
var
  lValue: Double;
begin
  Result := Trim(ABranchId);
  if Result = '' then
    Exit;
  lValue := StrToFloatDef(StringReplace(Result, ',', '.', [rfReplaceAll]), -1);
  if lValue <= 0 then
    Result := ''
  else
    Result := IntToStr(Trunc(lValue));
end;

procedure TDashboard.ApplyDefaultDashboardBranchesForUser;
var
  lIdx: Integer;
  lCount: Integer;
  lBranchId: string;
  lSource: string;
  lPos: Integer;
  lStart: Integer;
begin
  if not Assigned(FWebUserConfiguration) then
    Exit;
  if MainData.BranchIdType <> TBranchIdType.BranchGroup then
    Exit;
  if Length(FWebUserConfiguration.BranchList) > 0 then
    Exit;

  lSource := Trim(FUserBranchIds);
  if (lSource = '') or SameText(lSource, '0') then
    Exit;

  SetLength(FWebUserConfiguration.BranchList, 0);
  lCount := 0;
  lPos := 1;
  while lPos <= Length(lSource) do
  begin
    lStart := lPos;
    while (lPos <= Length(lSource)) and (lSource[lPos] <> ',') do
      Inc(lPos);
    lBranchId := NormalizeBranchId(Copy(lSource, lStart, lPos - lStart));
    Inc(lPos);
    if lBranchId = '' then
      Continue;
    SetLength(FWebUserConfiguration.BranchList, lCount + 1);
    FWebUserConfiguration.BranchList[lCount] := lBranchId;
    Inc(lCount);
  end;
end;

procedure TDashboard.RefreshBranchAccessMetadata;
begin
  SharedData.Dashboard.ClearBranchMetadataCache;
  FUserBranchIds := Await(SharedData.Dashboard.GetUserBranchesForUser(FUserId));
  FBranchStructureJSON := Await(SharedData.Dashboard.GetBranchStructure());
end;

function TDashboard.SortBranchIdsParameter: string;
var
  lIdx: integer;
  lBranchId: string;
begin
  Result := '';
  if not Assigned(FWebUserConfiguration) then
    Exit;

  for lIdx := 0 to Length(FWebUserConfiguration.BranchList) - 1 do
  begin
    lBranchId := NormalizeBranchId(FWebUserConfiguration.BranchList[lIdx]);
    if lBranchId = '' then
      Continue;
    // Always honour Branch / BranchGroup assignment — including for administrators.
    if not IsBranchAllowedForUser(lBranchId) then
      Continue;
    if Pos(',' + lBranchId + ',', ',' + Result + ',') > 0 then
      Continue;
    if Result <> '' then
      Result := Result + ',';
    Result := Result + lBranchId;
  end;
end;

procedure TDashboard.ReloadPersistedBranchListFromUserConfig;
begin
  if not Assigned(FWebUserConfiguration) then
    Exit;
  FWebUserConfiguration.BranchList := ParseBranchListFromUserConfigJson(FUserConfig.Config);
end;

function TDashboard.BranchIdsCsvToArray(const ABranchIdsCsv: string): TArray<string>;
var
  lParts: TArray<string>;
  lIdx: Integer;
  lCount: Integer;
  lPart: string;
begin
  SetLength(Result, 0);
  lCount := 0;
  if Trim(ABranchIdsCsv) = '' then
    Exit;

  lParts := ABranchIdsCsv.Split([',']);
  for lIdx := 0 to High(lParts) do
  begin
    lPart := NormalizeBranchId(lParts[lIdx]);
    if lPart = '' then
      Continue;
    SetLength(Result, lCount + 1);
    Result[lCount] := lPart;
    Inc(lCount);
  end;
end;

function TDashboard.ParseBranchListFromUserConfigJson(const AConfigJson: string): TArray<string>;
var
  lConfigJson: string;
  lIdsJson: string;
  lIdArray: TJSArray;
  lIdx: Integer;
  lCount: Integer;
  lParsed: TUserConfiguration;
  lConfigObj: JS.TJSObject;

  procedure AddId(const ABranchId: string);
  var
    lNormalized: string;
    lCheckIdx: Integer;
  begin
    lNormalized := NormalizeBranchId(ABranchId);
    if lNormalized = '' then
      Exit;
    for lCheckIdx := 0 to lCount - 1 do
      if Result[lCheckIdx] = lNormalized then
        Exit;
    SetLength(Result, lCount + 1);
    Result[lCount] := lNormalized;
    Inc(lCount);
  end;

begin
  SetLength(Result, 0);
  lCount := 0;
  lConfigJson := Trim(AConfigJson);
  if lConfigJson = '' then
    Exit;

  try
    lConfigObj := JS.toObject(TJSJSON.parse(lConfigJson));
    lParsed := TUserConfiguration.Create(lConfigObj);
    try
      for lIdx := 0 to Length(lParsed.BranchList) - 1 do
        AddId(lParsed.BranchList[lIdx]);
      if lCount > 0 then
        Exit;
    finally
      lParsed.Free;
    end;
  except
  end;

  lIdsJson := '[]';
  asm
    try {
      var parsed = JSON.parse(lConfigJson);
      var raw = parsed ? parsed.BranchList : null;
      var ids = [];
      if (raw && raw.length !== undefined) {
        for (var i = 0; i < raw.length; i++) {
          var id = String(raw[i]).trim();
          if (id !== '') {
            ids.push(id);
          }
        }
      } else if (typeof raw === 'string' && raw !== '') {
        var parsedList = JSON.parse(raw);
        if (parsedList && parsedList.length !== undefined) {
          for (var j = 0; j < parsedList.length; j++) {
            var sid = String(parsedList[j]).trim();
            if (sid !== '') {
              ids.push(sid);
            }
          }
        }
      }
      lIdsJson = JSON.stringify(ids);
    } catch (e) {
      lIdsJson = '[]';
    }
  end;

  if Trim(lIdsJson) <> '' then
  begin
    try
      lIdArray := TJSArray(TJSJSON.parse(lIdsJson));
      for lIdx := 0 to Trunc(lIdArray.Length) - 1 do
        AddId(String(lIdArray[lIdx]));
    except
    end;
  end;
end;

function TDashboard.HasExplicitBranchScope: Boolean;
begin
  Result := MainData.BranchIdType in [TBranchIdType.Branch, TBranchIdType.BranchGroup];
end;

function TDashboard.IsBranchAllowedForUser(const ABranchId: string): Boolean;
var
  lSource: string;
  lNormalized: string;
begin
  lNormalized := NormalizeBranchId(ABranchId);
  if lNormalized = '' then
    Exit(False);

  // Branch / BranchGroup profile must always be enforced (including admins).
  if HasExplicitBranchScope then
  begin
    lSource := Trim(FUserBranchIds);
    if (lSource = '') or SameText(lSource, '0') then
      Exit(False);
    Exit(Pos(',' + lNormalized + ',', ',' + lSource + ',') > 0);
  end;

  if AuthService.IsAdministrator or UserHasUnrestrictedBranches then
    Exit(True);

  lSource := Trim(FUserBranchIds);
  Result := Pos(',' + lNormalized + ',', ',' + lSource + ',') > 0;
end;

function TDashboard.FilterBranchStructureForUser(const ABranchStructure: string): string;
var
  lRegionArray: JS.TJSArray;
  lGroupArray: JS.TJSArray;
  lOutGroups: JS.TJSArray;
  lOutGroup: JS.TJSArray;
  lBranchObj: JS.TJSObject;
  lRegionIdx: Integer;
  lBranchIdx: Integer;
  lRegionName: string;
  lBranchId: string;
begin
  Result := '';
  if Trim(ABranchStructure) = '' then
    Exit;

  try
    lRegionArray := JS.toArray(TJSJSON.parse(ABranchStructure));
  except
    Exit;
  end;

  lOutGroups := TJSArray.new;
  for lRegionIdx := 0 to lRegionArray.Length - 1 do
  begin
    lGroupArray := JS.toArray(lRegionArray[lRegionIdx]);
    if lGroupArray.Length = 0 then
      Continue;

    lRegionName := Trim(String(lGroupArray[0]));
    if lRegionName = '' then
      lRegionName := 'Ungrouped';

    lOutGroup := TJSArray.new;
    lOutGroup.push(lRegionName);

    for lBranchIdx := 1 to lGroupArray.Length - 1 do
    begin
      lBranchObj := JS.toObject(lGroupArray[lBranchIdx]);
      lBranchId := NormalizeBranchId(Trim(String(lBranchObj['BranchId'])));
      if not IsBranchAllowedForUser(lBranchId) then
        Continue;
      lOutGroup.push(lBranchObj);
    end;

    // Keep the group only if it still has branches after filtering
    if lOutGroup.Length > 1 then
      lOutGroups.push(lOutGroup);
  end;

  Result := TJSJSON.stringify(lOutGroups);
end;

procedure TDashboard.ClampBranchListToUserAccess;
var
  lIdx: Integer;
  lBranchId: string;
  lClean: TArray<string>;
  lCount: Integer;
begin
  if not Assigned(FWebUserConfiguration) then
    Exit;

  SetLength(lClean, 0);
  lCount := 0;
  for lIdx := 0 to Length(FWebUserConfiguration.BranchList) - 1 do
  begin
    lBranchId := NormalizeBranchId(FWebUserConfiguration.BranchList[lIdx]);
    if not IsBranchAllowedForUser(lBranchId) then
      Continue;
    SetLength(lClean, lCount + 1);
    lClean[lCount] := lBranchId;
    Inc(lCount);
  end;
  FWebUserConfiguration.BranchList := lClean;
end;

function TDashboard.CollectAllBranchIdsFromStructure: string;
var
  lRegionArray: JS.TJSArray;
  lGroupArray: JS.TJSArray;
  lBranchObj: JS.TJSObject;
  lRegionIdx: Integer;
  lBranchIdx: Integer;
  lBranchId: string;
begin
  Result := '';
  if Trim(FBranchStructureJSON) = '' then
    Exit;

  try
    lRegionArray := JS.toArray(TJSJSON.parse(FBranchStructureJSON));
  except
    Exit;
  end;

  for lRegionIdx := 0 to lRegionArray.Length - 1 do
  begin
    lGroupArray := JS.toArray(lRegionArray[lRegionIdx]);
    if lGroupArray.Length < 2 then
      Continue;

    for lBranchIdx := 1 to lGroupArray.Length - 1 do
    begin
      lBranchObj := JS.toObject(lGroupArray[lBranchIdx]);
      lBranchId := NormalizeBranchId(Trim(String(lBranchObj['BranchId'])));
      if lBranchId = '' then
        Continue;
      if Pos(',' + lBranchId + ',', ',' + Result + ',') > 0 then
        Continue;
      if Result <> '' then
        Result := Result + ',';
      Result := Result + lBranchId;
    end;
  end;
end;

function TDashboard.ResolveEffectiveBranchIds: string;
var
  lIdx: Integer;
  lBranchId: string;
  lSource: string;
begin
  // 1) Explicit dashboard config selection wins when present
  Result := SortBranchIdsParameter;
  if Result <> '' then
    Exit;

  // 2) User profile branch assignment (Branch / BranchGroup)
  lSource := Trim(FUserBranchIds);
  if (lSource <> '') and not SameText(lSource, '0') then
  begin
    Result := '';
    lIdx := 1;
    while lIdx <= Length(lSource) do
    begin
      lBranchId := '';
      while (lIdx <= Length(lSource)) and (lSource[lIdx] <> ',') do
      begin
        lBranchId := lBranchId + lSource[lIdx];
        Inc(lIdx);
      end;
      Inc(lIdx);
      lBranchId := NormalizeBranchId(lBranchId);
      if (lBranchId <> '') and (Pos(',' + lBranchId + ',', ',' + Result + ',') = 0) then
      begin
        if Result <> '' then
          Result := Result + ',';
        Result := Result + lBranchId;
      end;
    end;
    if Result <> '' then
      Exit;
  end;

  // 3) Branch Id Type = All (or unresolved) => every active branch
  Result := CollectAllBranchIdsFromStructure;
end;

procedure TDashboard.StartDatePickerChange(Sender: TObject);
begin
  if FSuppressDateRefresh then
    Exit;
  FSuppressDateRefresh := True;
  try
  EndDatePicker.Date := StartDatePicker.Date + 7;
  finally
    FSuppressDateRefresh := False;
  end;
  if FDashboardReady then
    await(RefreshDashboard(0));
end;

procedure TDashboard.EndDatePickerChange(Sender: TObject);
begin
  if FSuppressDateRefresh then
    Exit;
  FSuppressDateRefresh := True;
  try
  StartDatePicker.Date := EndDatePicker.Date - 7;
  finally
    FSuppressDateRefresh := False;
  end;
  if FDashboardReady then
    await(RefreshDashboard(0));
end;

procedure TDashboard.GetUserDashboardItems;
var
  lRetval: TXDataClientResponse;
  lList: TJSArray;
  lIdx: integer;
  lUserId: integer;

begin
  lUserId := FUserId;
  if lUserId = 0 then
  lUserId := MainData.UserId;

  if lUserId <> 0 then
  begin
    if not Assigned(FDashboardItemTemplates) or (FDashboardItemTemplates.Count = 0) then
  begin
    FDashboardItemTemplates := Await(SharedData.Dashboard.GetDashboardItemTemplates(lUserId));
    end;
  end;

  ImplementParameters;
  if FDashboardList.Count = 0 then
    CreateDashboardShells;
  await(LoadAllWidgetData);
end;


//function TDashboard.GetTenantDashboardItems: TList<TDashboardItemTitle>;
procedure TDashboard.GetTenantDashboardItems;//: TList<TDashboardItemTitle>;
var
  lRetval: TXDataClientResponse;
//  lResponse: TJSObject;
  lList: TJSArray;
  lIdx: integer;
//  lCount: integer;
//  lDashboardItemTitles: TList<TDashboardItemTitle>;
  lTenantId: string;
begin
  lTenantId := MainData.TenantId;
  FDashboardItemTitles := Await(SharedData.Dashboard.GetTenantDashboardItems(lTenantId, FUserId));
end;


procedure TDashboard.UserDashboardButtonClick(Sender: TObject);
var
  lDashboardItemTitles: TList<TDashboardItemTitle>;
begin
//  lDashboardItemTitles := GetTenantDashboardItemsKSS;

  UserDashboardPopUp;
end;

procedure TDashboard.SaveUserDashboardItems(AUserDashboardItemTitles: TList<TDashboardItemTitle>);
//var
//  lUserDashboardItemTitles: TList<TDashboardItemTitle>;
begin
  Await(SharedData.Dashboard.SaveUserDashboardItemTitles(FUserId, AUserDashboardItemTitles));
end;

procedure TDashboard.UserDashboardPopUp;
var
  UserDashboardFrm: TUserDashboardForm;
  lDashboardItemTitles: TList<TDashboardItemTitle>;
begin
  UserDashboardFrm := TUserDashboardForm.Create(Self);
  try
    UserDashboardFrm.Popup := True;
    UserDashboardFrm.PopupOpacity := 1;
    await(TUserDashboardForm, UserDashboardFrm.Load());

    UserDashboardFrm.TenantDashboardItems := FDashboardItemTitles;
    await(TModalResult, UserDashboardFrm.Execute);
  finally
    if UserDashboardFrm.ModalResult = mrOk then
    begin
      CancelPendingWidgetOrderSave;
      FSuppressWidgetOrderSave := True;
      try
        FDashboardItemTitles := UserDashboardFrm.TenantDashboardItems;
        await(SaveUserDashboardItems(UserDashboardFrm.TenantDashboardItems));
        InvalidateDashboardDataCache;
        await(RefreshDashboardItems);
        CaptureWidgetOrderSignature;
      finally
        FSuppressWidgetOrderSave := False;
      end;
    end;

    UserDashboardFrm.Free;
    UserDashboardFrm := nil;
  end;

end;

function TDashboard.GetParameters(AParameters: TArray<String>; const ATitle: string): string;
var
  lIdx: Integer;
  lParamName: string;
  lParamValue: string;
  lDashboardParams: JS.TJSObject;
  lYearEnd: string;
  lYear: Integer;
  lCount: Integer;
begin
  lDashboardParams := JS.TJSObject.new;

  lCount := 0;
  try
    lCount := Length(AParameters);
  except
    lCount := 0;
  end;

  for lIdx := 0 to lCount - 1 do
  begin
    lParamName := AParameters[lIdx];

    if Assigned(FDashboardParams) then
      lParamValue := JS.toString(FDashboardParams.Properties[lParamName])
    else
      lParamValue := '';
    lDashboardParams.Properties[lParamName] := lParamValue;
  end;

  if SameText(Trim(ATitle), 'LFL Yearly Profit Comparison') then
  begin
    lYearEnd := string(lDashboardParams.Properties['YearEnd']);
    if lYearEnd = '' then
      lYearEnd := string(lDashboardParams.Properties['EndDate']);
    lYear := 0;
    if Length(lYearEnd) >= 10 then
      lYear := StrToIntDef(Copy(lYearEnd, 7, 4), 0);
    if lYear > 0 then
    begin
      lDashboardParams.Properties['YearStart'] := '01.01.' + IntToStr(lYear - 1);
      lDashboardParams.Properties['YearEnd'] := '31.12.' + IntToStr(lYear);
    end;
  end;

  result := JS.TJSJSON.stringify(lDashboardParams);
end;

procedure TDashboard.GetBranchList;
var
  lClaimBranchId: string;
begin
  FUserBranchIds := Await(SharedData.Dashboard.GetUserBranchesForUser(FUserId));

  // JWT branch claims are the session authorisation source for explicit branch assignment.
  if MainData.BranchIdType = TBranchIdType.Branch then
  begin
    lClaimBranchId := NormalizeBranchId(IntToStr(Trunc(MainData.BranchId)));
    if lClaimBranchId <> '' then
      FUserBranchIds := lClaimBranchId;
  end;
end;

procedure TDashboard.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WaitMessage := TWaitMessage.Create(Self);
  BranchTreeView := TTreeView.Create(Self);
  StartDatePicker := TDateTimePicker.Create('StartDate');
  EndDatePicker := TDateTimePicker.Create('EndDate');
  RefreshButton := TButton.Create('Refresh');
  ConfigurationButton := TButton.Create('Configuration');
  WebButton1 := TButton.Create(Self);
  UserDashboardButton := TButton.Create(Self);
  WidgetHostPanel := TPanel.Create('DashboardWidgetsRow');
  ChartTimer := TTimer.Create(Self);
  RefreshDashboardItemsTimer := TTimer.Create(Self);
  WidgetOrderSaveTimer := TTimer.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  BranchTreeView.BeforeLoadDFMValues;
  StartDatePicker.BeforeLoadDFMValues;
  EndDatePicker.BeforeLoadDFMValues;
  RefreshButton.BeforeLoadDFMValues;
  ConfigurationButton.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  UserDashboardButton.BeforeLoadDFMValues;
  WidgetHostPanel.BeforeLoadDFMValues;
  ChartTimer.BeforeLoadDFMValues;
  RefreshDashboardItemsTimer.BeforeLoadDFMValues;
  WidgetOrderSaveTimer.BeforeLoadDFMValues;
  try
    Name := 'Dashboard';
    Width := 802;
    Height := 677;
    Color := clBtnFace;
    ElementClassName := 'w-100 csy-dashboard-page';
    WidthPercent := 100.000000000000000000;
    WidthStyle := ssAuto;
    HeightStyle := ssAuto;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WaitMessage.SetParentComponent(Self);
    WaitMessage.Name := 'WaitMessage';
    WaitMessage.Left := 228;
    WaitMessage.Top := 576;
    WaitMessage.Width := 24;
    WaitMessage.Height := 24;
    WaitMessage.Margins.Left := 5;
    WaitMessage.Margins.Top := 5;
    WaitMessage.Margins.Right := 5;
    WaitMessage.Margins.Bottom := 5;
    WaitMessage.HeightStyle := ssAuto;
    WaitMessage.WidthStyle := ssAuto;
    WaitMessage.Visible := False;
    WaitMessage.ElementPosition := epAbsolute;
    WaitMessage.Picture.LoadFromFile('DashboardForm.WaitMessage.Picture.gif');
    BranchTreeView.SetParentComponent(Self);
    BranchTreeView.Name := 'BranchTreeView';
    BranchTreeView.Left := 8;
    BranchTreeView.Top := 24;
    BranchTreeView.Width := 244;
    BranchTreeView.Height := 385;
    BranchTreeView.ElementPosition := epAbsolute;
    BranchTreeView.HeightStyle := ssAuto;
    BranchTreeView.WidthStyle := ssAuto;
    BranchTreeView.HeightPercent := 100.000000000000000000;
    BranchTreeView.WidthPercent := 100.000000000000000000;
    BranchTreeView.TabOrder := 1;
    BranchTreeView.TabStop := True;
    StartDatePicker.SetParentComponent(Self);
    StartDatePicker.Name := 'StartDatePicker';
    StartDatePicker.Left := 16;
    StartDatePicker.Top := 480;
    StartDatePicker.Width := 170;
    StartDatePicker.Height := 22;
    StartDatePicker.HeightStyle := ssAuto;
    StartDatePicker.WidthStyle := ssAuto;
    StartDatePicker.BorderStyle := bsSingle;
    StartDatePicker.ChildOrder := 3;
    StartDatePicker.Color := clWhite;
    StartDatePicker.Date := 45579.658078703700000000;
    StartDatePicker.ElementPosition := epIgnore;
    StartDatePicker.Role := '';
    StartDatePicker.Text := '';
    StartDatePicker.Visible := False;
    SetEvent(StartDatePicker, Self, 'OnChange', 'StartDatePickerChange');
    EndDatePicker.SetParentComponent(Self);
    EndDatePicker.Name := 'EndDatePicker';
    EndDatePicker.Left := 16;
    EndDatePicker.Top := 508;
    EndDatePicker.Width := 170;
    EndDatePicker.Height := 22;
    EndDatePicker.HeightStyle := ssAuto;
    EndDatePicker.WidthStyle := ssAuto;
    EndDatePicker.BorderStyle := bsSingle;
    EndDatePicker.ChildOrder := 3;
    EndDatePicker.Color := clWhite;
    EndDatePicker.Date := 45579.658086701390000000;
    EndDatePicker.ElementPosition := epIgnore;
    EndDatePicker.Role := '';
    EndDatePicker.Text := '';
    EndDatePicker.Visible := False;
    SetEvent(EndDatePicker, Self, 'OnChange', 'EndDatePickerChange');
    RefreshButton.SetParentComponent(Self);
    RefreshButton.Name := 'RefreshButton';
    RefreshButton.Left := 16;
    RefreshButton.Top := 536;
    RefreshButton.Width := 96;
    RefreshButton.Height := 25;
    RefreshButton.Caption := 'Refresh';
    RefreshButton.ChildOrder := 4;
    RefreshButton.ElementClassName := 'btn csy-toolbar-btn csy-toolbar-btn-primary';
    RefreshButton.Enabled := False;
    RefreshButton.HeightPercent := 100.000000000000000000;
    RefreshButton.WidthPercent := 100.000000000000000000;
    SetEvent(RefreshButton, Self, 'OnClick', 'RefreshButtonClick');
    ConfigurationButton.SetParentComponent(Self);
    ConfigurationButton.Name := 'ConfigurationButton';
    ConfigurationButton.Left := 16;
    ConfigurationButton.Top := 624;
    ConfigurationButton.Width := 96;
    ConfigurationButton.Height := 25;
    ConfigurationButton.Caption := 'Configuration';
    ConfigurationButton.ChildOrder := 6;
    ConfigurationButton.ElementClassName := 'btn csy-toolbar-btn csy-toolbar-btn-secondary csy-config-hidden';
    ConfigurationButton.HeightPercent := 100.000000000000000000;
    ConfigurationButton.Visible := False;
    ConfigurationButton.WidthPercent := 100.000000000000000000;
    SetEvent(ConfigurationButton, Self, 'OnClick', 'ConfigurationButtonClick');
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 8;
    WebButton1.Top := 593;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Refresh NOT';
    WebButton1.ChildOrder := 7;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.Visible := False;
    WebButton1.WidthPercent := 100.000000000000000000;
    UserDashboardButton.SetParentComponent(Self);
    UserDashboardButton.Name := 'UserDashboardButton';
    UserDashboardButton.Left := 120;
    UserDashboardButton.Top := 624;
    UserDashboardButton.Width := 96;
    UserDashboardButton.Height := 25;
    UserDashboardButton.Caption := 'User Dashboard';
    UserDashboardButton.ElementClassName := 'btn btn-secondary';
    UserDashboardButton.ElementPosition := epAbsolute;
    UserDashboardButton.HeightPercent := 100.000000000000000000;
    UserDashboardButton.Visible := False;
    UserDashboardButton.WidthPercent := 100.000000000000000000;
    SetEvent(UserDashboardButton, Self, 'OnClick', 'UserDashboardButtonClick');
    WidgetHostPanel.SetParentComponent(Self);
    WidgetHostPanel.Name := 'WidgetHostPanel';
    WidgetHostPanel.Left := 0;
    WidgetHostPanel.Top := 120;
    WidgetHostPanel.Width := 800;
    WidgetHostPanel.Height := 1;
    WidgetHostPanel.ElementClassName := 'csy-dashboard-widgets w-100 mt-2';
    WidgetHostPanel.ElementPosition := epRelative;
    WidgetHostPanel.HeightStyle := ssAuto;
    WidgetHostPanel.WidthStyle := ssAuto;
    WidgetHostPanel.HeightPercent := 100.000000000000000000;
    WidgetHostPanel.WidthPercent := 100.000000000000000000;
    ChartTimer.SetParentComponent(Self);
    ChartTimer.Name := 'ChartTimer';
    ChartTimer.Enabled := False;
    ChartTimer.Interval := 100;
    SetEvent(ChartTimer, Self, 'OnTimer', 'ChartTimerTimer');
    ChartTimer.Left := 832;
    ChartTimer.Top := 464;
    RefreshDashboardItemsTimer.SetParentComponent(Self);
    RefreshDashboardItemsTimer.Name := 'RefreshDashboardItemsTimer';
    RefreshDashboardItemsTimer.Enabled := False;
    SetEvent(RefreshDashboardItemsTimer, Self, 'OnTimer', 'RefreshDashboardItemsTimerTimer');
    RefreshDashboardItemsTimer.Left := 224;
    RefreshDashboardItemsTimer.Top := 480;
    WidgetOrderSaveTimer.SetParentComponent(Self);
    WidgetOrderSaveTimer.Name := 'WidgetOrderSaveTimer';
    WidgetOrderSaveTimer.Enabled := False;
    WidgetOrderSaveTimer.Interval := 400;
    SetEvent(WidgetOrderSaveTimer, Self, 'OnTimer', 'WidgetOrderSaveTimerTimer');
    WidgetOrderSaveTimer.Left := 320;
    WidgetOrderSaveTimer.Top := 480;
  finally
    WaitMessage.AfterLoadDFMValues;
    BranchTreeView.AfterLoadDFMValues;
    StartDatePicker.AfterLoadDFMValues;
    EndDatePicker.AfterLoadDFMValues;
    RefreshButton.AfterLoadDFMValues;
    ConfigurationButton.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    UserDashboardButton.AfterLoadDFMValues;
    WidgetHostPanel.AfterLoadDFMValues;
    ChartTimer.AfterLoadDFMValues;
    RefreshDashboardItemsTimer.AfterLoadDFMValues;
    WidgetOrderSaveTimer.AfterLoadDFMValues;
  end;
end;

end.


